/**
 * @name dashboard.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\dashboard.js
 */

//import { apiCall, getBaseDir } from './utils.js';

const XLSX = require('xlsx');
var getBaseDir = null, apiCall = null, userHasRole = null, getCategoryColor = null, currencyFormat = null, isCurrentUserInAdminFeatureBlacklist = null, getPatientRoleByPatientType = null, getPatientTypeDataByAcronym = null, getPatientTypeDataByRole = null, getAgendaCategoryByRole = null, mountSortList = null, isUserLoggedIn = null;

$(function () {
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        userHasRole = utils.userHasRole;
        getCategoryColor = utils.getCategoryColor;
        currencyFormat = utils.currencyFormat;
        isCurrentUserInAdminFeatureBlacklist = utils.isCurrentUserInAdminFeatureBlacklist;
        getPatientRoleByPatientType = utils.getPatientRoleByPatientType;
        getPatientTypeDataByAcronym = utils.getPatientTypeDataByAcronym;
        getPatientTypeDataByRole = utils.getPatientTypeDataByRole;
        getAgendaCategoryByRole = utils.getAgendaCategoryByRole;
        mountSortList = utils.mountSortList;
        isUserLoggedIn = utils.isUserLoggedIn;

        if (!isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir())
            return;

        new Dashboard(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
            userHasRole: utils.userHasRole,
            getNextBusinessDay: utils.getNextBusinessDay,
            isUserLoggedIn: utils.isUserLoggedIn
        });
    });
});

class Dashboard {
    constructor(onloadList = false, deps = {}) {
        this.deps = deps;
        this.responses = {};

        this.onlyFranchise = false;

        this.periods = {
            'HOMEPAGE_PIT_PN_LAST_7_DAYS': 'TODAY',
            'HOMEPAGE_SCHEDULEMENT_REPORT_PN': 'TOMORROW',
            'HOMEPAGE_HUNTER_INSIGHTS': 'DEFAULT',
            'HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS': 'DEFAULT',
            'HOMEPAGE_HUNTER_GLASS_DOOR': 'DEFAULT',
            'HOMEPAGE_AGENDA_REPORT': 'DEFAULT',
            'HOMEPAGE_MANAGER': 'DEFAULT'
        }

        this.categories = {
            'HOMEPAGE_AGENDA_REPORT': ''
        }

        this.charts = {
            'PIT_PN_REPORT': false,
            'PN_PR_REPORT': false,
            'BEST_HUNTERS_REPORT': false,
            'HUNTER_INSIGHTS_REPORT': false,
            'HUNTER_GOALS_REPORT': false,
            //'HUNTER_OVERVIEW_REPORT': false,
            //'HUNTER_GLASS_DOOR': false
        }

        this.cache = {
            'HUNTER_PN_GOAL_VALUE': 0
        }

        if (onloadList) {
            this.getCurrentUserDashboardBots();
        }
    }

    /**
     * @name getCurrentUserDashboardBots
     */
    getCurrentUserDashboardBots() {
        let self = this;
        async function OnBusinessReady() {
            jQuery('.vertical-nav-menu').metisMenu().show();
            $(".js-admin-dashboard").block(window._loader.loading);

            let neededModules = [];
            let neededModulesAfter = [];

            if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR')) {
                await self.loadBusinessInsightsPitPimPnLast7Days(true);
                await self.loadBusinessInsightSchedulments7Days(true);
                await self.loadBusinessHuntersGlassDoor(true);
                await self.loadBusinessAgenda(true);
                self.loadBusinessHuntersOverviewInsights(true);
            }
            if (self.deps.userHasRole('MANAGER') || self.deps.userHasRole('COMMERCIAL_ASSISTANT')) {
                if (self.deps.userHasRole('MANAGER')) {
                    await self.loadBusinessInsightSchedulments7Days(true);
                    await self.loadBusinessHuntersGlassDoor(true);
                }
                //self.loadBusinessInsightsPitPimPnLast7Days(true);
                await self.loadBusinessInsightsPitPimPnLast7Days(true);
                await self.loadBusinessAgenda(true);
                self.loadManagerInsights(true);
            }
            if (self.deps.userHasRole('SELLER')) {
                await self.loadHunterInsights(true);
                await self.loadHunterGoals(true);
                await self.loadBusinessHuntersGlassDoor(true);
            }

            Promise.all(neededModules).then(() => {
                $(".js-admin-dashboard").unblock()
            }).then(() => {
                Promise.all(neededModulesAfter).then(() => {
                    //console.log('loaded all');
                });
            });

            self.bindDOMEvents();
        };
        window.businessReadyFunctions.push(OnBusinessReady);
    }

    loadBusinessInsightsPitPimPnLast7Days(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_PIT_PN_LAST_7_DAYS',
                    period: self.periods.HOMEPAGE_PIT_PN_LAST_7_DAYS,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    console.log('dashboard.js/business/insights', 'HOMEPAGE_PIT_PN_LAST_7_DAYS', res);

                    self.responses.HOMEPAGE_PIT_PN_LAST_7_DAYS = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_PIT_PN_LAST_7_DAYS', 'PIT_PN_REPORT', self.periods.HOMEPAGE_PIT_PN_LAST_7_DAYS);
                        //self.renderDashboardReport('HOMEPAGE_PIT_PN_LAST_7_DAYS', 'PN_PR_REPORT', self.periods.HOMEPAGE_PIT_PN_LAST_7_DAYS);
                    }
                    resolve(true);
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadBusinessInsightSchedulments7Days(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_SCHEDULEMENT_REPORT_PN',
                    period: self.periods.HOMEPAGE_SCHEDULEMENT_REPORT_PN,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_SCHEDULEMENT_REPORT_PN', res);

                    self.responses.HOMEPAGE_SCHEDULEMENT_REPORT_PN = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_SCHEDULEMENT_REPORT_PN', 'AGENDA_STATE_SCHEDULEMENTS_PN_REPORT', self.periods.HOMEPAGE_SCHEDULEMENT_REPORT_PN);
                        self.renderDashboardReport('HOMEPAGE_SCHEDULEMENT_REPORT_PN', 'BEST_HUNTERS_REPORT', self.periods.HOMEPAGE_SCHEDULEMENT_REPORT_PN);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadHunterInsights(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-hunter-insights-skeleton").block(window._loader.loading);

            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_HUNTER_INSIGHTS',
                    period: self.periods.HOMEPAGE_HUNTER_INSIGHTS,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_HUNTER_INSIGHTS', res);

                    $(".js-hunter-insights-skeleton").unblock();
                    self.responses.HOMEPAGE_HUNTER_INSIGHTS = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HUNTER_SCHEDULES', self.periods.HOMEPAGE_HUNTER_INSIGHTS);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadHunterGoals(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-hunter-goals-skeleton").block(window._loader.loading);
            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_HUNTER_GOALS',
                    period: self.periods.HOMEPAGE_HUNTER_GOALS,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_HUNTER_GOALS', res);

                    $(".js-hunter-goals-skeleton").unblock();
                    self.responses.HOMEPAGE_HUNTER_GOALS = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HUNTER_GOALS', self.periods.HOMEPAGE_HUNTER_GOALS);
                        self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HUNTER_NOT_ATTENDENT_LIST', self.periods.HOMEPAGE_HUNTER_GOALS);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadManagerInsights(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-manager-goals-skeleton").block(window._loader.loading);

            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_MANAGER_INSIGHTS',
                    period: self.periods.HOMEPAGE_MANAGER
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_MANAGER_INSIGHTS', res);

                    $(".js-manager-goals-skeleton").unblock();
                    self.responses.MANAGER_DASHBOARD_INDEXES = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_MANAGER', 'MANAGER_DASHBOARD_INDEXES', self.periods.HOMEPAGE_MANAGER);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadBusinessHuntersOverviewInsights(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-homepage-hunter-overview-today").block(window._loader.loading);
            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS',
                    period: self.periods.HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_HUNTER_INSIGHTS', res);

                    $("#js-report-homepage-hunter-overview-today").unblock();
                    self.responses.HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HUNTER_OVERVIEW_INSIGHTS', self.periods.HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadBusinessHuntersGlassDoor(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-homepage-hunter-glass-door-today").block(window._loader.loading);
            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_HUNTER_GLASS_DOOR',
                    period: self.periods.HOMEPAGE_HUNTER_GLASS_DOOR,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_HUNTER_INSIGHTS', res);

                    $("#js-report-homepage-hunter-glass-door-today").unblock();
                    self.responses.HOMEPAGE_HUNTER_GLASS_DOOR = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HOMEPAGE_HUNTER_GLASS_DOOR', self.periods.HOMEPAGE_HUNTER_GLASS_DOOR);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    loadBusinessAgenda(render = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            $("#js-report-homepage-agenda-today").block(window._loader.loading);
            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/insights',
                data: {
                    report: 'HOMEPAGE_AGENDA_REPORT',
                    period: self.periods.HOMEPAGE_AGENDA_REPORT,
                    categories: self.categories.HOMEPAGE_AGENDA_REPORT,
                    franchise: self.onlyFranchise
                },
                successCallback: function (res) {
                    resolve(true);

                    console.log('dashboard.js/business/insights', 'HOMEPAGE_HUNTER_INSIGHTS', res);

                    $("#js-report-homepage-agenda-today").unblock();
                    self.responses.HOMEPAGE_AGENDA_REPORT = res.data;

                    if (render) {
                        self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HOMEPAGE_AGENDA_REPORT', self.periods.HOMEPAGE_AGENDA_REPORT);
                    }
                },
                errorCallback(err) {
                    reject(err);
                }
            });
        });
    }

    renderDashboardReport(dash_type, sub_type, period) {
        let
            Find_PatientTypeData_PR = getPatientTypeDataByRole('PACIENTE_RETORNO'),
            Find_PatientTypeData_PN = getPatientTypeDataByRole('PACIENTE_NOVO');
        console.log('Find_PatientTypeData_PR', Find_PatientTypeData_PR);
        console.log('Find_PatientTypeData_PN', Find_PatientTypeData_PN);
        switch (dash_type) {
            case 'HOMEPAGE_PIT_PN_LAST_7_DAYS': {
                var data = this.responses.HOMEPAGE_PIT_PN_LAST_7_DAYS;
                let self = this;
                switch (sub_type) {
                    case 'PIT_PN_REPORT': {
                        let render = {
                            chart: {
                                type: this.periods.HOMEPAGE_PIT_PN_LAST_7_DAYS === 'TODAY' ? "bar" : "area",
                                height: 318,
                                width: "100%",
                                stacked: false,
                                foreColor: "#999",
                                events: {
                                    click: function (event, chartContext, config) {
                                        if (isCurrentUserInAdminFeatureBlacklist())
                                            return;
                                        if (!window._sessionData.isInMainBusiness)
                                            return;
                                        // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                                        $("#modal-dashboard-branch-report-new-contracts").modal('show');
                                        let pointIndex = config.dataPointIndex == -1 ? 0 : config.dataPointIndex;
                                        let date = data.labels[pointIndex];
                                        $('.js-view-business-branch-report-new-patient-container').block(window._loader.loading);
                                        $(".js-view-business-branch-report-new-contracts-dialog-title-id").html(data.labels[pointIndex]);
                                        self.deps.apiCall({
                                            method: 'GET',
                                            endpoint: 'api/v1/employee/agenda_report',
                                            data: {
                                                report: 'HOMEPAGE_BRANCH_REPORT_NEW_CONTRACTS',
                                                date: date
                                            },
                                            successCallback: function (res) {
                                                console.log('dashboard.js/click/.js-dashboard-business-branch-new-contracts-view-report', 'HOMEPAGE_BRANCH_REPORT_NEW_CONTRACTS', res);
                                                self.responses.HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS = res;
                                                self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS');
                                            },
                                            errorCallback(err) {
                                                $('.js-view-business-branch-report-new-patient-container').block(window._loader.error);
                                                console.error('dashboard.js/click/.js-dashboard-business-branch-new-contracts-view-report', 'HOMEPAGE_BRANCH_REPORT_NEW_CONTRACTS', err);
                                            }
                                        });
                                    }
                                }
                            },
                            plotOptions: {
                                area: {
                                    dataLabels: {
                                        enabled: true
                                    },
                                    columnWidth: "75%",
                                    endingShape: "rounded"
                                }
                            },
                            colors: ["#ff0000", "#67eb5b", "#5bebda"],
                            series: [{
                                name: "PIT",
                                data: data.results.PIT
                            }, {
                                name: "PIM",
                                data: data.results.PIM
                            }, {
                                name: Find_PatientTypeData_PN['SIGLA'],
                                data: data.results[Find_PatientTypeData_PN['SIGLA']]
                            }],
                            stroke: {
                                curve: 'smooth'
                            },
                            labels: data.labels,
                            xaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                axisTicks: {
                                    show: !1
                                },
                                crosshairs: {
                                    show: !1
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        fontSize: "14px"
                                    }
                                }
                            },
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: !1
                                    }
                                },
                                yaxis: {
                                    lines: {
                                        show: !1
                                    }
                                }
                            },
                            yaxis: {
                                axisBorder: {
                                    show: true
                                },
                                labels: {
                                    show: true
                                }
                            },
                            legend: {
                                showForSingleSeries: true,
                                position: 'bottom',
                                horizontalAlign: 'center',
                                offsetY: 3,
                                itemMargin: {
                                    horizontal: 10
                                },
                                containerMargin: {
                                    left: 20,
                                    right: 20
                                },
                                containerHeight: 25 // Set the height of the legend container
                            },
                            tooltip: {
                                shared: !0,
                                intersect: false
                            }
                        };
                        if (!this.charts.PIT_PN_REPORT) {
                            this.charts.PIT_PN_REPORT = new ApexCharts(document.querySelector("#js-report-homepage-pit-pim-last-7-days"), render);
                            this.charts.PIT_PN_REPORT.render();
                        } else {
                            this.charts.PIT_PN_REPORT.updateOptions(render);
                        }
                        break;
                    }
                    case 'PN_PR_REPORT': {
                        let render = {
                            chart: {
                                type: this.periods.HOMEPAGE_PIT_PN_LAST_7_DAYS === 'TODAY' ? "bar" : "area",
                                height: 318,
                                width: "100%",
                                stacked: false,
                                foreColor: "#999"
                            },
                            plotOptions: {
                                area: {
                                    dataLabels: {
                                        enabled: true
                                    },
                                    columnWidth: "75%",
                                    endingShape: "rounded"
                                }
                            },
                            colors: ["#67eb5b", "#5bebda"],
                            series: [{
                                name: Find_PatientTypeData_PN['SIGLA'],
                                data: data.results[Find_PatientTypeData_PN['SIGLA']]
                            }, {
                                name: Find_PatientTypeData_PR['SIGLA'],
                                data: data.results[Find_PatientTypeData_PR['SIGLA']]
                            }],
                            stroke: {
                                curve: 'smooth'
                            },
                            labels: data.labels,
                            xaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                axisTicks: {
                                    show: !1
                                },
                                crosshairs: {
                                    show: !1
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        fontSize: "14px"
                                    }
                                }
                            },
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: !1
                                    }
                                },
                                yaxis: {
                                    lines: {
                                        show: !1
                                    }
                                }
                            },
                            yaxis: {
                                axisBorder: {
                                    show: true
                                },
                                labels: {
                                    show: true
                                }
                            },
                            legend: {
                                showForSingleSeries: true,
                                position: 'bottom',
                                horizontalAlign: 'center',
                                offsetY: 3,
                                itemMargin: {
                                    horizontal: 10
                                },
                                containerMargin: {
                                    left: 20,
                                    right: 20
                                },
                                containerHeight: 25 // Set the height of the legend container
                            },
                            tooltip: {
                                shared: !0,
                                intersect: false
                            }
                        };

                        if (!this.charts.PN_PR_REPORT) {
                            this.charts.PN_PR_REPORT = new ApexCharts(document.querySelector("#js-report-homepage-pn-pr-last-7-days"), render);
                            this.charts.PN_PR_REPORT.render();
                        } else {
                            this.charts.PN_PR_REPORT.updateOptions(render);
                        }
                        break;
                    }
                }
                break;
            }
            case 'HOMEPAGE_SCHEDULEMENT_REPORT_PN': {
                var data = this.responses.HOMEPAGE_SCHEDULEMENT_REPORT_PN;
                switch (sub_type) {
                    case 'AGENDA_STATE_SCHEDULEMENTS_PN_REPORT': {
                        let labels = [];
                        let dataChart = [];

                        for (let i in Object.keys(data.results.SCHEDULEMENTS_TODAY)) {
                            let result = Object.keys(data.results.SCHEDULEMENTS_TODAY)[i];
                            labels.push(result);
                        }
                        for (let i in data.results.SCHEDULEMENTS_TODAY) {
                            let result = data.results.SCHEDULEMENTS_TODAY[i];
                            dataChart.push(result);
                        }

                        let render = {
                            chart: {
                                type: "donut",
                                width: "100%",
                                height: "400px",
                                stacked: !0,
                                foreColor: "#999"
                            },
                            series: dataChart,
                            labels: labels,
                            xaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                axisTicks: {
                                    show: !1
                                },
                                crosshairs: {
                                    show: !1
                                },
                                labels: {
                                    show: !1,
                                    style: {
                                        fontSize: "14px"
                                    }
                                }
                            },
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: !1
                                    }
                                },
                                yaxis: {
                                    lines: {
                                        show: !1
                                    }
                                }
                            },
                            yaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                labels: {
                                    show: !1
                                }
                            },
                            legend: {
                                showForSingleSeries: true,
                                position: 'bottom',
                                horizontalAlign: 'center',
                                offsetY: 3,
                                itemMargin: {
                                    horizontal: 10
                                },
                                containerMargin: {
                                    left: 20,
                                    right: 20
                                },
                                containerHeight: 25 // Set the height of the legend container
                            },
                            tooltip: {
                                shared: !0,
                                intersect: false
                            }
                        };
                        var chart = new ApexCharts(document.querySelector("#js-report-homepage-agenda-state-today"), render);
                        chart.render();
                        break;
                    }
                    case 'BEST_HUNTERS_REPORT': {
                        let huntersLabels = [];
                        let huntersData = [];

                        for (let i in Object.keys(data.results.BEST_SCHEDULERS)) {
                            let result = Object.keys(data.results.BEST_SCHEDULERS)[i];
                            huntersLabels.push(result);
                        }
                        for (let i in data.results.BEST_SCHEDULERS) {
                            let result = data.results.BEST_SCHEDULERS[i];
                            huntersData.push(result);
                        }

                        let render = {
                            chart: {
                                type: "donut",
                                width: "100%",
                                height: "400px",
                                stacked: !0,
                                foreColor: "#999"
                            },
                            series: huntersData,
                            labels: huntersLabels,
                            xaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                axisTicks: {
                                    show: !1
                                },
                                crosshairs: {
                                    show: !1
                                },
                                labels: {
                                    show: !1,
                                    style: {
                                        fontSize: "14px"
                                    }
                                }
                            },
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: !1
                                    }
                                },
                                yaxis: {
                                    lines: {
                                        show: !1
                                    }
                                }
                            },
                            yaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                labels: {
                                    show: !1
                                }
                            },
                            legend: {
                                showForSingleSeries: true,
                                position: 'bottom',
                                horizontalAlign: 'center',
                                offsetY: 3,
                                itemMargin: {
                                    horizontal: 10
                                },
                                containerMargin: {
                                    left: 20,
                                    right: 20
                                },
                                containerHeight: 25 // Set the height of the legend container
                            },
                            tooltip: {
                                shared: !0,
                                intersect: false
                            }
                        };

                        if (!this.charts.BEST_HUNTERS_REPORT) {
                            this.charts.BEST_HUNTERS_REPORT = new ApexCharts(document.querySelector("#js-report-homepage-best-schedulers-today"), render);
                            this.charts.BEST_HUNTERS_REPORT.render();
                        } else {
                            this.charts.BEST_HUNTERS_REPORT.updateOptions(render);
                        }
                        break;
                    }
                }
                break;
            }
            case 'HOMEPAGE_HUNTER_INSIGHTS': {
                switch (sub_type) {
                    case 'HUNTER_SCHEDULES': {
                        var data = this.responses.HOMEPAGE_HUNTER_INSIGHTS;
                        let labels = [];
                        let dataChart = [];

                        for (let i in Object.keys(data.results.SCHEDULEMENTS_TODAY)) {
                            let result = Object.keys(data.results.SCHEDULEMENTS_TODAY)[i];
                            labels.push(result);
                        }
                        for (let i in data.results.SCHEDULEMENTS_TODAY) {
                            let result = data.results.SCHEDULEMENTS_TODAY[i];
                            dataChart.push(result);
                        }

                        let render = {
                            chart: {
                                type: "donut",
                                width: "100%",
                                height: "400px",
                                stacked: !0,
                                foreColor: "#999",
                            },
                            series: dataChart,
                            labels: labels,
                            xaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                axisTicks: {
                                    show: !1
                                },
                                crosshairs: {
                                    show: !1
                                },
                                labels: {
                                    show: !1,
                                    style: {
                                        fontSize: "14px"
                                    },
                                }
                            },
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: !1
                                    }
                                },
                                yaxis: {
                                    lines: {
                                        show: !1
                                    }
                                }
                            },
                            yaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                labels: {
                                    show: !1
                                }
                            },
                            legend: {
                                showForSingleSeries: true,
                                position: 'bottom',
                                horizontalAlign: 'center',
                                offsetY: 3,
                                itemMargin: {
                                    horizontal: 10
                                },
                                containerMargin: {
                                    left: 20,
                                    right: 20
                                },
                                containerHeight: 25 // Set the height of the legend container
                            },
                            tooltip: {
                                shared: !0,
                                intersect: false
                            }
                        };

                        if (!this.charts.HUNTER_INSIGHTS_REPORT) {
                            this.charts.HUNTER_INSIGHTS_REPORT = new ApexCharts(document.querySelector("#js-report-homepage-hunter-meta"), render);
                            this.charts.HUNTER_INSIGHTS_REPORT.render();
                        } else {
                            this.charts.HUNTER_INSIGHTS_REPORT.updateOptions(render);
                        }
                        break;
                    }
                    case 'HUNTER_GOALS': {
                        var data = this.responses.HOMEPAGE_HUNTER_GOALS;
                        this.cache.HUNTER_PN_GOAL_VALUE = 7 * parseInt(data.results.ContagemAtendidosAtual);
                        this.cache.HUNTER_PN_GOAL_STRING = `${data.results.ContagemAtendidosAtual}`;
                        let render = {
                            chart: {
                                type: 'area',
                                height: 318,
                                width: "100%",
                                stacked: false,
                                foreColor: "#999"
                            },
                            plotOptions: {
                                area: {
                                    dataLabels: {
                                        enabled: true
                                    },
                                    columnWidth: "75%",
                                    endingShape: "rounded"
                                }
                            },
                            title: {
                                text: this.cache.HUNTER_PN_GOAL_STRING + ` (R$****)`,
                                offsetX: 30,
                                style: {
                                    fontSize: '24px',
                                    cssClass: 'apexcharts-yaxis-title'
                                }
                            },
                            subtitle: {
                                text: 'Atendidos Este Mês',
                                offsetX: 30,
                                style: {
                                    fontSize: '14px',
                                    cssClass: 'apexcharts-yaxis-title'
                                }
                            },
                            colors: ["#67eb5b", "#5bebda"],
                            series: [
                                {
                                    name: "Este mês",
                                    data: data.results.AtendidosAtual
                                },
                                {
                                    name: "Último mês",
                                    data: data.results.AtendidosComparacao
                                }
                            ],
                            stroke: {
                                curve: 'smooth'
                            },
                            labels: data.labels,
                            xaxis: {
                                axisBorder: {
                                    show: !1
                                },
                                axisTicks: {
                                    show: !1
                                },
                                crosshairs: {
                                    show: !1
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        fontSize: "14px"
                                    }
                                }
                            },
                            grid: {
                                xaxis: {
                                    lines: {
                                        show: !1
                                    }
                                },
                                yaxis: {
                                    lines: {
                                        show: !1
                                    }
                                }
                            },
                            yaxis: {
                                axisBorder: {
                                    show: true
                                },
                                labels: {
                                    show: true
                                }
                            },
                            legend: {
                                showForSingleSeries: true,
                                position: 'bottom',
                                horizontalAlign: 'center',
                                offsetY: 3,
                                itemMargin: {
                                    horizontal: 10
                                },
                                containerMargin: {
                                    left: 20,
                                    right: 20
                                },
                                containerHeight: 25 // Set the height of the legend container
                            },
                            tooltip: {
                                shared: !0,
                                intersect: false
                            }
                        };
                        if (!this.charts.HUNTER_GOALS_REPORT) {
                            this.charts.HUNTER_GOALS_REPORT = new ApexCharts(document.querySelector("#js-report-homepage-hunter-goals"), render);
                            this.charts.HUNTER_GOALS_REPORT.render();
                        } else {
                            this.charts.HUNTER_GOALS_REPORT.updateOptions(render);
                        }
                        break;
                    }
                    case 'HUNTER_NOT_ATTENDENT_LIST': {
                        const percentageDifferenceAgendamentos = parseFloat(((this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemTotalAgendamentosAtual - this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemTotalAgendamentosAnterior) / this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemTotalAgendamentosAnterior) * 100).toFixed(2);
                        const percentageDifferenceAgendamentosTaxaAgendXAtendidos = parseFloat(((this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemAtendidosAtual - this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemAtendidosAnterior) / this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemAtendidosAnterior) * 100).toFixed(2);
                        const percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram = parseFloat(((this.responses.HOMEPAGE_HUNTER_GOALS.results.NaoCompareceuAtualTotal - this.responses.HOMEPAGE_HUNTER_GOALS.results.NaoCompareceuAnteriorTotal) / this.responses.HOMEPAGE_HUNTER_GOALS.results.NaoCompareceuAnteriorTotal) * 100).toFixed(2);

                        $('.js-hunter-total-schedulments-percentage').removeClass('text-success');
                        $('.js-hunter-total-schedulments-percentage').removeClass('text-danger');
                        $('.js-hunter-total-schedulments-percentage').removeClass('text-primary');
                        if (percentageDifferenceAgendamentos > 0) {
                            $('.js-hunter-total-schedulments-percentage').html(`+${(percentageDifferenceAgendamentos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentos) ? percentageDifferenceAgendamentos : 100}%`);
                            $('.js-hunter-total-schedulments-percentage').addClass('text-success');
                        } else if (percentageDifferenceAgendamentos < 0) {
                            $('.js-hunter-total-schedulments-percentage').html(`${(percentageDifferenceAgendamentos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentos) ? percentageDifferenceAgendamentos : 100}%`);
                            $('.js-hunter-total-schedulments-percentage').addClass('text-danger');
                        } else {
                            $('.js-hunter-total-schedulments-percentage').html(`0%`);
                            $('.js-hunter-total-schedulments-percentage').addClass('text-primary');
                        }
                        $('.js-hunter-total-schedules').attr('title', `Sua quantidade de agendamentos ${percentageDifferenceAgendamentos > 0 ? 'aumentou' : 'diminuiu'} ${percentageDifferenceAgendamentos !== "Infinity" && !isNaN(percentageDifferenceAgendamentos) ? percentageDifferenceAgendamentos : 100}% comparado ao mesmo período do mês passado, onde você realizou ${this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemTotalAgendamentosAnterior} agendamentos.`)

                        $('.js-hunter-total-attend-percentage').removeClass('text-success');
                        $('.js-hunter-total-attend-percentage').removeClass('text-danger');
                        $('.js-hunter-total-attend-percentage').removeClass('text-primary');
                        if (percentageDifferenceAgendamentosTaxaAgendXAtendidos > 0) {
                            $('.js-hunter-total-attend-percentage').html(`+${(percentageDifferenceAgendamentosTaxaAgendXAtendidos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXAtendidos) ? percentageDifferenceAgendamentosTaxaAgendXAtendidos : 100}%`);
                            $('.js-hunter-total-attend-percentage').addClass('text-success');
                        } else if (percentageDifferenceAgendamentosTaxaAgendXAtendidos < 0) {
                            $('.js-hunter-total-attend-percentage').html(`${(percentageDifferenceAgendamentosTaxaAgendXAtendidos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXAtendidos) ? percentageDifferenceAgendamentosTaxaAgendXAtendidos : 100}%`);
                            $('.js-hunter-total-attend-percentage').addClass('text-danger');
                        } else {
                            $('.js-hunter-total-attend-percentage').html(`0%`);
                            $('.js-hunter-total-attend-percentage').addClass('text-primary');
                        }
                        $('.js-hunter-total-attend-current-count').html(`${this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemAtendidosAtual}`);
                        $('.js-hunter-total-attend-past-count').attr('title', `Sua taxa de Pacientes Atendidos ${percentageDifferenceAgendamentosTaxaAgendXAtendidos > 0 ? 'aumentou' : 'diminuiu'} ${(percentageDifferenceAgendamentosTaxaAgendXAtendidos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXAtendidos) ? percentageDifferenceAgendamentosTaxaAgendXAtendidos : 100}% comparado com o mesmo período do mês passado, onde você teve ${this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemAtendidosAnterior} Pacientes Atendidos.`);

                        $('.js-hunter-total-not-attended-percentage').removeClass('text-success');
                        $('.js-hunter-total-not-attended-percentage').removeClass('text-danger');
                        $('.js-hunter-total-not-attended-percentage').removeClass('text-primary');
                        if (percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram > 0) {
                            $('.js-hunter-total-not-attended-percentage').html(`+${(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) ? percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram : 100}%`);
                            $('.js-hunter-total-not-attended-percentage').addClass('text-danger');
                        } else if (percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram < 0) {
                            $('.js-hunter-total-not-attended-percentage').html(`${(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) ? percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram : 100}%`);
                            $('.js-hunter-total-not-attended-percentage').addClass('text-success');
                        } else {
                            $('.js-hunter-total-not-attended-percentage').html(`0%`);
                            $('.js-hunter-total-not-attended-percentage').addClass('text-primary');
                        }
                        //console.log('this.responses.HOMEPAGE_HUNTER_GOALS.results', this.responses.HOMEPAGE_HUNTER_GOALS.results);
                        $('.js-hunter-total-non-attended-current-count').html(`${this.responses.HOMEPAGE_HUNTER_GOALS.results.NaoCompareceuAtualTotal}`);
                        $('.js-hunter-total-not-attended-past-count').attr('title', `Sua taxa de Pacientes que Não Compareceram ${percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram > 0 ? 'aumentou' : 'diminuiu'} ${(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) ? percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram : 100}% comparado com o mesmo período do mês passado, onde você teve ${this.responses.HOMEPAGE_HUNTER_GOALS.results.NaoCompareceuAnteriorTotal} Pacientes que Não Compareceram.`);

                        //console.log('percentageDifferenceAgendamentos', percentageDifferenceAgendamentos);
                        //console.log('percentageDifferenceAgendamentosTaxaAgendXAtendidos', percentageDifferenceAgendamentosTaxaAgendXAtendidos);
                        //console.log('percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram', percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram);
                        $('.js-hunter-total-schedulments').html(`
                            ${this.responses.HOMEPAGE_HUNTER_GOALS.results.ContagemTotalAgendamentosAtual}
                        `);
                        $('.js-hunter-total-attend').html(`
                            ${this.responses.HOMEPAGE_HUNTER_GOALS.results.TaxaDeAgendamentosXAtendidosAtual}%
                        `);
                        $('.js-hunter-total-not-attended').html(`
                            ${this.responses.HOMEPAGE_HUNTER_GOALS.results.TaxaDeAgendamentosXNaoCompareceramAtual}%
                        `);

                        var data = this.responses.HOMEPAGE_HUNTER_GOALS.results.Atendidos;
                        let html = ``;
                        for (let i in data) {
                            let Paciente = data[i];
                            let branchName = '';
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == Paciente.FILIAL_ID) {
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    break;
                                }
                            }
                            html += `
                                <tr>
                                    <td data-label="#">${Paciente.ID}</td>
                                    <td data-label="FILIAL">${branchName}</td>
                                    <td data-label="CATEGORIA">
                                        <button class="btn" style="background-color:${getCategoryColor(Paciente.CATEGORIA)}; color:#FFF;">${Paciente.CATEGORIA}</button></button>
                                    </td>
                                    <td data-label="NOME">${Paciente.PRIMEIRO_NOME} ${Paciente.SOBRENOME}</td>
                                    <td data-label="WHATSAPP">
                                        <a href="javascript:void(0);" onClick="window.copyToClipboardV2('${Paciente.FONE_CELULAR}');window.toast({error: false, text: 'WhatsApp copiado com sucesso!'});">
                                            ${Paciente.FONE_CELULAR}
                                        </a>
                                    </td>
                                    <td data-label="DATA AGEND.">${Paciente.DATA_INICIO}</td>
                                    <td data-label="HORÁRIO">${Paciente.HORA_INICIO_FORMATED} - ${Paciente.HORA_FINAL_FORMATED}</td>
                                </tr>
                            `;
                        }

                        if (html == '') {
                            $('.js-report-hunter-schedules-list').html('<tr><td colspan="7">Não foram encontrados registros de agendamentos.</td></tr>');
                        } else {
                            $('.js-report-hunter-schedules-list').html(html);
                        }

                        var data = this.responses.HOMEPAGE_HUNTER_GOALS.results.Cancelados;
                        html = ``;
                        for (let i in data) {
                            let Paciente = data[i];
                            let branchName = '';
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == Paciente.FILIAL_ID) {
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    break;
                                }
                            }
                            html += `
                                <tr>
                                    <td data-label="#">${Paciente.ID}</td>
                                    <td data-label="FILIAL">${branchName}</td>
                                    <td data-label="NOME">${Paciente.PRIMEIRO_NOME} ${Paciente.SOBRENOME}</td>
                                    <td data-label="WHATSAPP">
                                        <a href="javascript:void(0);" onClick="window.copyToClipboardV2('${Paciente.FONE_CELULAR}');window.toast({error: false, text: 'WhatsApp copiado com sucesso!'});">
                                            ${Paciente.FONE_CELULAR}
                                        </a>
                                    </td>
                                    <td data-label="DATA AGEND.">${Paciente.DATA_INICIO}</td>
                                    <td data-label="HORÁRIO">${Paciente.HORA_INICIO_FORMATED} - ${Paciente.HORA_FINAL_FORMATED}</td>
                                </tr>
                            `;
                        }

                        if (html == '') {
                            $('.js-report-hunter-cancelled-schedules-list').html('<tr><td colspan="7">Parabéns! Não houve cancelamentos.</td></tr>');
                        } else {
                            $('.js-report-hunter-cancelled-schedules-list').html(html);
                        }

                        var data = this.responses.HOMEPAGE_HUNTER_GOALS.results.NaoCompareceu;
                        html = ``;
                        for (let i in data) {
                            let Paciente = data[i];
                            let branchName = '';
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == Paciente.FILIAL_ID) {
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    break;
                                }
                            }
                            html += `
                                <tr>
                                    <td data-label="#">${Paciente.ID}</td>
                                    <td data-label="FILIAL">${branchName}</td>
                                    <td data-label="NOME">${Paciente.PRIMEIRO_NOME} ${Paciente.SOBRENOME}</td>
                                    <td data-label="WHATSAPP">
                                        <a href="javascript:void(0);" onClick="window.copyToClipboardV2('${Paciente.FONE_CELULAR}');window.toast({error: false, text: 'WhatsApp copiado com sucesso!'});">
                                            ${Paciente.FONE_CELULAR}
                                        </a>
                                    </td>
                                    <td data-label="DATA AGEND.">${Paciente.DATA_INICIO}</td>
                                    <td data-label="HORÁRIO">${Paciente.HORA_INICIO_FORMATED} - ${Paciente.HORA_FINAL_FORMATED}</td>
                                </tr>
                            `;
                        }

                        if (html == '') {
                            $('.js-report-hunter-not-attended-list').html('<tr><td colspan="7">Parabéns! não foi encontrado pacientes que não compareceram.</td></tr>');
                        } else {
                            $('.js-report-hunter-not-attended-list').html(html);
                        }

                        var data = this.responses.HOMEPAGE_HUNTER_GOALS.results.EmAtendimento;
                        html = ``;
                        for (let i in data) {
                            let Paciente = data[i];
                            let branchName = '';
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == Paciente.FILIAL_ID) {
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    break;
                                }
                            }
                            html += `
                                <tr>
                                    <td data-label="#">${Paciente.ID}</td>
                                    <td data-label="FILIAL">${branchName}</td>
                                    <td data-label="NOME">${Paciente.PRIMEIRO_NOME} ${Paciente.SOBRENOME}</td>
                                    <td data-label="WHATSAPP">
                                        <a href="javascript:void(0);" onClick="window.copyToClipboardV2('${Paciente.FONE_CELULAR}');window.toast({error: false, text: 'WhatsApp copiado com sucesso!'});">
                                            ${Paciente.FONE_CELULAR}
                                        </a>
                                    </td>
                                    <td data-label="DATA AGEND.">${Paciente.DATA_INICIO}</td>
                                    <td data-label="HORÁRIO">${Paciente.HORA_INICIO_FORMATED} - ${Paciente.HORA_FINAL_FORMATED}</td>
                                </tr>
                            `;
                        }

                        if (html == '') {
                            $('.js-report-hunter-being-attended-list').html('<tr><td colspan="7">Nennhum dos seus agendamentos está Em Atendimento, ainda.</td></tr>');
                        } else {
                            $('.js-report-hunter-being-attended-list').html(html);
                        }
                        break;
                    }
                    case 'HUNTER_OVERVIEW_INSIGHTS': {
                        let html = `<div class="accordion mb-3 js-report-homepage-hunters-overview-accordion" id="accordionHunterOverview"></div>`;
                        $('#js-report-homepage-hunter-overview-today').html(html);

                        html = '';
                        for (let i = 0; i < Object.entries(this.responses.HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS.results).length; ++i) {
                            const hunter = Object.keys(this.responses.HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS.results)[i];
                            const data = Object.entries(this.responses.HOMEPAGE_HUNTER_OVERVIEW_INSIGHTS.results)[i][1];

                            var tomorrowHunterSchedules = 0;

                            var dataBestSchedulers = this.responses.HOMEPAGE_SCHEDULEMENT_REPORT_PN.results.BEST_SCHEDULERS;
                            for (let x = 0; x < Object.entries(dataBestSchedulers).length; x++) {
                                const hunter2 = Object.keys(dataBestSchedulers)[x];
                                const data2 = Object.entries(dataBestSchedulers)[x][1];
                                if (hunter2 == hunter) {
                                    tomorrowHunterSchedules = data2;
                                }
                            }

                            html = `
                                    <div class="accordion-item js-homepage-hunter-overview-insight" data-hunter="${hunter}">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHunterOverview${hunter}" aria-expanded="true" aria-controls="collapseHunterOverview${hunter}">
                                                Métricas Hunter: ${hunter}
                                            </button>
                                        </h2>
                                        <div id="collapseHunterOverview${hunter}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionHunterOverview">
                                            <div class="accordion-body">
                                                <div class="card">
                                                    <div class="row"> 
                                                        <div class="col-sm-12">
                                                            <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card js-hunter-${hunter}-goals-skeleton">
                                                                <div class="widget-chat-wrapper-outer">
                                                                    <div class="widget-chart-content">
                                                                        <h6 class="widget-subheading">Comissão</h6>
                                                                        <div class="widget-chart-flex">
                                                                            <div class="widget-numbers mb-0 w-100">
                                                                                <div class="widget-chart-flex">
                                                                                    <div class="fsize-4">
                                                                                        <small class="opacity-5"></small>
                                                                                        <span class="js-hunter-${hunter}-total-comission">0</span>
                                                                                        <br>
                                                                                        <p>Período atual</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card js-hunter-${hunter}-goals-skeleton">
                                                                <div class="widget-chat-wrapper-outer">
                                                                    <div class="widget-chart-content">
                                                                        <h6 class="widget-subheading">Total de Agendamentos</h6>
                                                                        <div class="widget-chart-flex">
                                                                            <div class="widget-numbers mb-0 w-100">
                                                                                <div class="widget-chart-flex">
                                                                                    <div class="fsize-4">
                                                                                        <small class="opacity-5"></small>
                                                                                        <span class="js-hunter-${hunter}-total-schedulments">0</span>
                                                                                        <br>
                                                                                        <p>Período atual</p>
                                                                                    </div>
                                                                                    <div class="ml-auto">
                                                                                        <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted text-right">
                                                                                            <span class="text-success pl-2 js-hunter-${hunter}-total-schedulments-percentage">+0%</span> <i class="fas fa-info-circle js-hunter-${hunter}-total-schedules" data-tippy-content="Tooltip on top"></i>
                                                                                            <br>
                                                                                            <p>vs Últ.Mês</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card js-hunter-${hunter}-goals-skeleton">
                                                                <div class="widget-chat-wrapper-outer">
                                                                    <div class="widget-chart-content">
                                                                        <h6 class="widget-subheading"><span class="js-hunter-${hunter}-total-attend-current-count">0</span> Atendidos</h6>
                                                                        <div class="widget-chart-flex">
                                                                            <div class="widget-numbers mb-0 w-100">
                                                                                <div class="widget-chart-flex">
                                                                                    <div class="fsize-4">
                                                                                        <small class="opacity-5"></small>
                                                                                        <span class="js-hunter-${hunter}-total-attend">0</span>
                                                                                        <br>
                                                                                        <p>foram atendidos</p>
                                                                                    </div>
                                                                                    <div class="ml-auto">
                                                                                        <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted text-right">
                                                                                            <span class="text-success pl-2 js-hunter-${hunter}-total-attend-percentage">+0%</span> <i class="fas fa-info-circle js-hunter-${hunter}-total-attend-past-count" data-tippy-content="Tooltip on top"></i>
                                                                                            <br>
                                                                                            <p>vs mesmo período do Últ.Mês</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card js-hunter-${hunter}-goals-skeleton">
                                                                <div class="widget-chat-wrapper-outer">
                                                                    <div class="widget-chart-content">
                                                                        <h6 class="widget-subheading"><span class="js-hunter-${hunter}-total-non-attended-current-count">0</span> Não compareceram</h6>
                                                                        <div class="widget-chart-flex">
                                                                            <div class="widget-numbers mb-0 w-100">
                                                                                <div class="widget-chart-flex">
                                                                                    <div class="fsize-4">
                                                                                        <small class="opacity-5"></small>
                                                                                        <span class="js-hunter-${hunter}-total-not-attended">0</span>
                                                                                        <br>
                                                                                        <p>não compareceram</p>
                                                                                    </div>
                                                                                    <div class="ml-auto">
                                                                                        <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted text-right">
                                                                                            <span class="text-success pl-2 js-hunter-${hunter}-total-not-attended-percentage">+0%</span> <i class="fas fa-info-circle js-hunter-${hunter}-total-not-attended-past-count" data-tippy-content="Tooltip on top"></i>
                                                                                            <br>
                                                                                            <p>vs mesmo período do Últ.Mês</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card js-hunter-${hunter}-goals-skeleton">
                                                                <div class="widget-chat-wrapper-outer">
                                                                    <div class="widget-chart-content">
                                                                        <h6 class="widget-subheading"><span class="js-hunter-${hunter}-total-contacts-today">Qtd de Leads Contatados Hoje</h6>
                                                                        <div class="widget-chart-flex">
                                                                            <div class="widget-numbers mb-0 w-100">
                                                                                <div class="widget-chart-flex">
                                                                                    <div class="fsize-4">
                                                                                        <small class="opacity-5"></small>
                                                                                        <span class="js-hunter-${hunter}-contacts-today-value">0</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="card-shadow-primary mb-3 widget-chart widget-chart2 text-left card js-hunter-${hunter}-goals-skeleton">
                                                                <div class="widget-chat-wrapper-outer">
                                                                    <div class="widget-chart-content">
                                                                        <h6 class="widget-subheading"><span class="js-hunter-${hunter}-total-tomorrow-current-count">Agendamentos p/ próximo dia útil</h6>
                                                                        <div class="widget-chart-flex">
                                                                            <div class="widget-numbers mb-0 w-100">
                                                                                <div class="widget-chart-flex">
                                                                                    <div class="fsize-4">
                                                                                        <small class="opacity-5"></small>
                                                                                        <span class="js-hunter-${hunter}-total-tomorrow">${tomorrowHunterSchedules}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `;

                            if (data.ContagemTotalAgendamentosAtual == 0 && data.ContagemAtendidosAtual == 0 && data.NaoCompareceuAtualTotal == 0)
                                continue;

                            $('.js-report-homepage-hunters-overview-accordion').append(html);
                        }
                        break;
                    }
                    case 'HOMEPAGE_HUNTER_GLASS_DOOR': {
                        //console.log('this.responses.HOMEPAGE_HUNTER_GLASS_DOOR', this.responses.HOMEPAGE_HUNTER_GLASS_DOOR);
                        //console.log('Object.entries(this.responses.HOMEPAGE_HUNTER_GLASS_DOOR.results)', Object.entries(this.responses.HOMEPAGE_HUNTER_GLASS_DOOR.results));
                        $('#js-report-homepage-hunter-glass-door-today').html(`
                            <table id="table-js-report-hunters-glass-door-list" class="mb-0 table table-bordered table-striped table-hover responsive-table">
                                <thead>
                                    <tr>
                                        <th>Filial</th>
                                        <!--<th>I.A Mabel</th>-->
                                        <th>Clínica</th>
                                        ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<th>${attendant}</th>` : '').join('')}
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody class="js-report-hunters-glass-door-list">
                                    <tr><td colspan="5">Carregando...</td></tr>
                                </tbody>
                                <tfoot class="js-report-hunters-glass-door-footer">
                                </tfoot>
                            </table>
                        `);

                        this.responses.HOMEPAGE_HUNTER_GLASS_DOOR_EXPORT = [];

                        let html = '',
                            countIdx = 0,
                            countTotalHunter = 0,
                            countTotalClinica = 0,
                            countTotalRobos = [],
                            countTotalTotal = 0,
                            foundBranches = [],
                            notFoundBranches = [];
                        for (let i in this.responses.HOMEPAGE_HUNTER_GLASS_DOOR.results) {
                            let glassDoorRowInfo = this.responses.HOMEPAGE_HUNTER_GLASS_DOOR.results[i];

                            let branchName = '';
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == glassDoorRowInfo.FILIAL_ID) {
                                    if ((this.onlyFranchise && window._sessionData.businessBranches[x].FRANQUIADO == 0) || (!this.onlyFranchise && window._sessionData.businessBranches[x].FRANQUIADO == 1))
                                        continue;
                                    if (window._sessionData.businessBranches[x].ATIVO == 0)
                                        continue;
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    this.responses.HOMEPAGE_HUNTER_GLASS_DOOR.results[i].FILIAL = branchName;
                                    foundBranches.push(window._sessionData.businessBranches[x].ID);
                                    break;
                                }
                            }

                            if (branchName == '') {
                                this.responses.HOMEPAGE_HUNTER_GLASS_DOOR.results[i].FILIAL = '';
                            }

                            if (branchName == '')
                                continue;

                            let countAll = parseInt(glassDoorRowInfo.AGENDAMENTO_HUNTER) + parseInt(glassDoorRowInfo.AGENDAMENTO_CLINICA);
                            for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                                countAll += parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]);
                            }

                            html += `
                                <tr class="js-dashboard-business-branch-new-patients-view-report" data-bs-toggle="modal" data-bs-target="#modal-dashboard-branch-report-new-patients" data-filial="${glassDoorRowInfo.FILIAL_ID}" data-filial-nome="${branchName}">
                                    <td data-label="Filial">${branchName} (${glassDoorRowInfo.FILIAL_ID})</td>
                                    <!--<td data-label="I.A Mabel">${glassDoorRowInfo.AGENDAMENTO_HUNTER}</td>-->
                                    <td data-label="Clínica">${glassDoorRowInfo.AGENDAMENTO_CLINICA}</td>
                                    ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<td data-label="${attendant}">${glassDoorRowInfo[`AGENDAMENTO_ROBO_${idx}`]}</td>` : '').join('')}
                                    <td data-label="Total">${countAll}</td>
                                </tr>
                            `;

                            countTotalHunter += parseInt(glassDoorRowInfo.AGENDAMENTO_HUNTER);
                            countTotalClinica += parseInt(glassDoorRowInfo.AGENDAMENTO_CLINICA);
                            for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                                //console.log(`parseInt(glassDoorRowInfo['AGENDAMENTO_ROBO_${i}'])`, window._sessionData.organicAttendantList[i], parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]));
                                countTotalRobos[window._sessionData.organicAttendantList[i]] =
                                    countTotalRobos[window._sessionData.organicAttendantList[i]] ?
                                        parseInt(countTotalRobos[window._sessionData.organicAttendantList[i]]) + parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]) :
                                        parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]);
                            }
                            countTotalTotal = countTotalTotal + countAll;
                            countIdx++;

                            this.responses.HOMEPAGE_HUNTER_GLASS_DOOR_EXPORT.push({
                                'FILIAL': branchName,
                                'HUNTER': parseInt(glassDoorRowInfo.AGENDAMENTO_HUNTER),
                                'CLINICA': parseInt(glassDoorRowInfo.AGENDAMENTO_CLINICA),
                                ...window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? { [`ROBO ${idx + 1}`]: parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${idx}`]) } : {}),
                                'TOTAL': countAll,
                            })
                        }

                        for (let x in window._sessionData.businessBranches) {
                            let found = false;
                            for (let y in foundBranches) {
                                if (window._sessionData.businessBranches[x].ID === foundBranches[y]) {
                                    found = true;
                                    break;
                                }
                            }
                            if (!found)
                                notFoundBranches.push(window._sessionData.businessBranches[x])
                        }

                        for (let x in notFoundBranches) {
                            let notFoundBranchesData = notFoundBranches[x];
                            if (notFoundBranchesData.FILIAL == 'THE QUIRO' || notFoundBranchesData.ATIVO == 0 || (this.onlyFranchise && notFoundBranchesData.FRANQUIADO == 0) || (!this.onlyFranchise && notFoundBranchesData.FRANQUIADO == 1))
                                continue;
                            html += `
                                <tr>
                                    <td data-label="Filial">${notFoundBranchesData.FILIAL} (${notFoundBranchesData.ID})</td>
                                    <!--<td data-label="I.A Mabel">0</td>-->
                                    <td data-label="Clínica">0</td>
                                    ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<td data-label="${attendant}">0</td>` : '').join('')}
                                    <td data-label="Total">0</td>
                                </tr>
                            `;

                            this.responses.HOMEPAGE_HUNTER_GLASS_DOOR_EXPORT.push({
                                'FILIAL': notFoundBranchesData.FILIAL,
                                'HUNTER': 0,
                                'CLINICA': 0,
                                ...window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? { [`ROBO ${idx + 1}`]: 0 } : {}),
                                'TOTAL': 0,
                            })
                        }

                        this.responses.HOMEPAGE_HUNTER_GLASS_DOOR_EXPORT.push({
                            'FILIAL': 'Total',
                            'HUNTER': countTotalHunter,
                            'CLINICA': countTotalClinica,
                            ...window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? { [`ROBO ${idx + 1}`]: countTotalRobos[attendant] } : {}),
                            'TOTAL': countTotalTotal,
                        })

                        //console.log('countTotalRobos', countTotalRobos);

                        $('.js-report-hunters-glass-door-footer').html(`<tr>
                            <td data-label="Total"><b>TOTAL:</b></td>
                            <!--<td data-label="I.A Mabel"><b>${countTotalHunter}</b></td>-->
                            <td data-label="Clínica"><b>${countTotalClinica}</b></td>
                            ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<td data-label="${attendant}"><b>${countTotalRobos[attendant]}</b></td>` : '').join('')}
                            <td data-label="Total"><b>${countTotalTotal}</b></td>
                        </tr>`);
                        $('.js-report-hunters-glass-door-list').html(html);
                        mountSortList('#table-js-report-hunters-glass-door-list', '.js-report-hunters-glass-door-footer tr:first td', 1)
                        break;
                    }
                    case 'HOMEPAGE_AGENDA_REPORT': {
                        //console.log('this.responses.HOMEPAGE_AGENDA_REPORT', this.responses.HOMEPAGE_AGENDA_REPORT);
                        //console.log('Object.entries(this.responses.HOMEPAGE_AGENDA_REPORT.results)', Object.entries(this.responses.HOMEPAGE_AGENDA_REPORT.results));
                        $('#js-report-homepage-agenda-today').html(`
                            <table id="table-js-report-agenda-content" class="mb-0 table table-bordered table-striped table-hover responsive-table">
                                <thead>
                                    <tr>
                                        <th>Filial</th>
                                        <!--<th>I.A Mabel</th>-->
                                        <th>Clínica</th>
                                        ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<th>${attendant}</th>` : '').join('')}
                                        <th>Total</th>
                                        <th>Total encaixes</th>
                                    </tr>
                                </thead>
                                <tbody class="js-report-agenda-content">
                                    <tr><td colspan="5">Carregando...</td></tr>
                                </tbody>
                                <tfoot class="js-report-agenda-content-footer">
                                </tfoot>
                            </table>
                        `);

                        this.responses.HOMEPAGE_AGENDA_REPORT_EXPORT = [];

                        let html = '',
                            countIdx = 0,
                            countTotalHunter = 0,
                            countTotalClinica = 0,
                            countTotalRobos = [],
                            countTotalTotal = 0,
                            countTotalEncaixes = 0,
                            foundBranches = [],
                            notFoundBranches = [];
                        for (let i in this.responses.HOMEPAGE_AGENDA_REPORT.results.agenda_info) {
                            let glassDoorRowInfo = this.responses.HOMEPAGE_AGENDA_REPORT.results.agenda_info[i];
                            let encaixeInfo = {}, foundEncaixe = false;
                            for (let i in this.responses.HOMEPAGE_AGENDA_REPORT.results.encaixe_info) {
                                if (this.responses.HOMEPAGE_AGENDA_REPORT.results.encaixe_info[i].FILIAL_ID == glassDoorRowInfo.FILIAL_ID) {
                                    if ((this.onlyFranchise && this.responses.HOMEPAGE_AGENDA_REPORT.results.encaixe_info[i].FRANQUIADO == 0) || (!this.onlyFranchise && this.responses.HOMEPAGE_AGENDA_REPORT.results.encaixe_info[i].FRANQUIADO == 1))
                                        continue;
                                    if (this.responses.HOMEPAGE_AGENDA_REPORT.results.encaixe_info[i].ATIVO == 0)
                                        continue;
                                    encaixeInfo = this.responses.HOMEPAGE_AGENDA_REPORT.results.encaixe_info[i];
                                    foundEncaixe = true;
                                    break;
                                }
                            }
                            if (!foundEncaixe) {
                                encaixeInfo.ENCAIXE_TOTAL = 0;
                            }

                            let branchName = '';
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == glassDoorRowInfo.FILIAL_ID) {
                                    if ((this.onlyFranchise && window._sessionData.businessBranches[x].FRANQUIADO == 0) || (!this.onlyFranchise && window._sessionData.businessBranches[x].FRANQUIADO == 1))
                                        continue;
                                    if (window._sessionData.businessBranches[x].ATIVO == 0)
                                        continue;
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    this.responses.HOMEPAGE_AGENDA_REPORT.results.agenda_info[i].FILIAL = branchName;
                                    foundBranches.push(window._sessionData.businessBranches[x].ID);
                                    break;
                                }
                            }

                            if (branchName == '') {
                                this.responses.HOMEPAGE_AGENDA_REPORT.results.agenda_info[i].FILIAL = '';
                            }

                            let countAll = parseInt(glassDoorRowInfo.AGENDAMENTO_HUNTER) + parseInt(glassDoorRowInfo.AGENDAMENTO_CLINICA);
                            for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                                countAll += parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]);
                            }

                            html += `
                                <tr class="js-dashboard-business-branch-agenda-view-report" data-bs-toggle="modal" data-bs-target="#modal-dashboard-branch-report-new-patients" data-filial="${glassDoorRowInfo.FILIAL_ID}" data-filial-nome="${branchName}">
                                    <td data-label="Filial">${branchName} (${glassDoorRowInfo.FILIAL_ID})</td>
                                    <!--<td data-label="I.A Mabel">${glassDoorRowInfo.AGENDAMENTO_HUNTER}</td>-->
                                    <td data-label="Clínica">${glassDoorRowInfo.AGENDAMENTO_CLINICA}</td>
                                    ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<td data-label="${attendant}">${glassDoorRowInfo[`AGENDAMENTO_ROBO_${idx}`]}</td>` : '').join('')}
                                    <td data-label="Total">${countAll}</td>
                                    <td data-label="Total encaixes">${parseInt(encaixeInfo.ENCAIXE_TOTAL)}</td>
                                </tr>
                            `;

                            countTotalHunter += parseInt(glassDoorRowInfo.AGENDAMENTO_HUNTER);
                            countTotalClinica += parseInt(glassDoorRowInfo.AGENDAMENTO_CLINICA);
                            for (let i = 0; i < window._sessionData.organicAttendantList.length; i++) {
                                //console.log('parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`])', parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]));
                                countTotalRobos[window._sessionData.organicAttendantList[i]] =
                                    countTotalRobos[window._sessionData.organicAttendantList[i]] ?
                                        parseInt(countTotalRobos[window._sessionData.organicAttendantList[i]]) + parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]) :
                                        parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${i}`]);
                            }
                            countTotalTotal = countTotalTotal + countAll;
                            countTotalEncaixes += parseInt(encaixeInfo.ENCAIXE_TOTAL);
                            countIdx++;

                            this.responses.HOMEPAGE_AGENDA_REPORT_EXPORT.push({
                                'FILIAL': branchName,
                                'HUNTER': parseInt(glassDoorRowInfo.AGENDAMENTO_HUNTER),
                                'CLINICA': parseInt(glassDoorRowInfo.AGENDAMENTO_CLINICA),
                                ...window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? { [`ROBO ${idx + 1}`]: parseInt(glassDoorRowInfo[`AGENDAMENTO_ROBO_${idx}`]) } : {}),
                                'TOTAL': countAll,
                                'TOTAL ENCAIXES': parseInt(encaixeInfo.ENCAIXE_TOTAL),
                            })
                        }

                        for (let x in window._sessionData.businessBranches) {
                            let found = false;
                            for (let y in foundBranches) {
                                if (window._sessionData.businessBranches[x].ID === foundBranches[y]) {
                                    found = true;
                                    break;
                                }
                            }
                            if (!found)
                                notFoundBranches.push(window._sessionData.businessBranches[x])
                        }

                        for (let x in notFoundBranches) {
                            let notFoundBranchesData = notFoundBranches[x];
                            if (notFoundBranchesData.FILIAL == 'THE QUIRO' || notFoundBranchesData.ATIVO == 0 || (this.onlyFranchise && notFoundBranchesData.FRANQUIADO == 0) || (!this.onlyFranchise && notFoundBranchesData.FRANQUIADO == 1))
                                continue;
                            html += `
                                <tr>
                                    <td data-label="Filial">${notFoundBranchesData.FILIAL} (${notFoundBranchesData.ID})</td>
                                    <!--<td data-label="I.A Mabel">0</td>-->
                                    <td data-label="Clínica">0</td>
                                    <!--<td data-label="1">0</td>-->
                                    ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<td data-label="${attendant}">0</td>` : '').join('')}
                                    <td data-label="Total">0</td>
                                    <td data-label="Total Encaixes">0</td>
                                </tr>
                            `;

                            this.responses.HOMEPAGE_AGENDA_REPORT_EXPORT.push({
                                'FILIAL': notFoundBranchesData.FILIAL,
                                'HUNTER': 0,
                                'CLINICA': 0,
                                ...window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? { [`ROBO ${idx + 1}`]: 0 } : {}),
                                'TOTAL': 0,
                                'TOTAL ENCAIXES': 0,
                            })
                        }

                        this.responses.HOMEPAGE_AGENDA_REPORT_EXPORT.push({
                            'FILIAL': 'Total',
                            'HUNTER': countTotalHunter,
                            'CLINICA': countTotalClinica,
                            ...window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? { [`ROBO ${idx + 1}`]: countTotalRobos[attendant] } : {}),
                            'TOTAL': countTotalTotal,
                            'TOTAL ENCAIXES': countTotalEncaixes,
                        })

                        $('.js-report-agenda-content-footer').html(`<tr>
                            <td data-label="Total"><b>TOTAL:</b></td>
                            <!--<td data-label="I.A Mabel"><b>${countTotalHunter}</b></td>-->
                            <td data-label="Clínica"><b>${countTotalClinica}</b></td>
                            ${window._sessionData.activeOrganicAttendantList.map((attendant, idx) => attendant != null ? `<td data-label="${attendant}"><b>${countTotalRobos[attendant]}</b></td>` : '').join('')}
                            <td data-label="Total"><b>${countTotalTotal}</b></td>
                            <td data-label="Total Encaixes"><b>${countTotalEncaixes}</b></td>
                        </tr>`)

                        $('.js-report-agenda-content').html(html);
                        mountSortList('#table-js-report-agenda-content', '.js-report-agenda-content-footer tr:first td', 1, 2)
                        break;
                    }
                    case 'HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS': {
                        var data = this.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS.data;
                        $('.js-view-business-branch-report-new-patients-dialog-title-id').html(`${this.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS_PRESET.filialNome} (#${this.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS_PRESET.filialId}) - ${this.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS.start_date} ${this.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS.end_date ? ' ~ ' + this.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS.end_date : ''}`)
                        $('.js-view-business-branch-report-new-patient-container').html(`
                            <table id="js-view-business-branch-report-new-patient-table" class="table-striped table-hover w-100 responsive-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>ID</th>
                                        <th>Categoria</th>
                                        <th>Data</th>
                                        <th>Cliente</th>
                                        <th>Origem</th>
                                        <th>Doutor</th>
                                        <th>Contato</th>
                                    </tr>
                                </thead>
                                <tbody class="js-business-branch-report-new-patientes-table-list">
                                    
                                </tbody>
                                <tfoot class="js-business-branch-report-new-patientes-table-footer">
                                </tfoot>
                            </table>
                        `)

                        let html = '',
                            countTotalSchedules = 0;

                        for (let i = 0; i < Object.entries(data).length; ++i) {
                            let hunterName = Object.keys(data)[i];
                            let info = Object.entries(data)[i];
                            let agendaHtml = '';
                            let countSchedules = 0;

                            //console.log('hunterName', hunterName);
                            //console.log('info', info);

                            for (let x = 0; x < info[1].length; ++x) {
                                const agendamento = info[1][x];
                                const clientDados = agendamento.obj.CLIENTE_DADOS.split("|");
                                const $color = getCategoryColor(agendamento.obj.CATEGORIA);
                                let isEncaixe = false;

                                let logs = '';
                                let agendaLogs = JSON.parse(agendamento.obj.AGENDA_LOGS) || [];
                                for (let i = 0; i < agendaLogs.length; ++i) {
                                    let obj1 = agendaLogs[i];
                                    logs += `${obj1.CATEGORIA} - ${obj1.USUARIO_DATA} - ${obj1.USUARIO_LOGIN}&#013;&#013;`

                                    if (obj1.CATEGORIA == getAgendaCategoryByRole('AGENDADO')) {
                                        if (moment(obj1.USUARIO_DATA).isSame(moment(agendamento.obj.DATA_INICIO), 'day')) {
                                            isEncaixe = true;
                                        }
                                    }
                                }

                                let origin = '';
                                if (agendamento.obj.ORIGEM_ID !== null) {
                                    for (let i = 0; i < window._sessionData.origins.length; ++i) {
                                        if (window._sessionData.origins[i].ID == agendamento.obj.ORIGEM_ID) {
                                            origin = window._sessionData.origins[i].ORIGEM;
                                            break;
                                        }
                                    }
                                }

                                agendaHtml += `
                                    <tr data-href="#" style="${isEncaixe ? 'background:rgba(245, 212, 66, 0.3); color:#000;' : ''}">
                                        <td><i class="fas fa-info" data-tippy-content="${logs}"></i></td>
                                        <td data-label="ID">${agendamento.obj.ID}</td>
                                        <td data-label="CATEGORIA" style="background-color:${$color} !important; color:black;">${agendamento.obj.CATEGORIA}</td>
                                        <td data-label="DATA">${agendamento.startFormatted} das ${agendamento.obj.HORA_INICIO_FORMATED} às ${agendamento.obj.HORA_FINAL_FORMATED}</td>
                                        <td data-label="CLIENTE">${clientDados[0]}</td>
                                        <td data-label="ORIGEM">${origin}</td>
                                        <td data-label="DOUTOR(A)">${agendamento.obj.DOUTOR_NOME} (${agendamento.obj.DOUTORES_ID})</td>
                                        <td data-label="CONTATO">${clientDados[1]}</td>
                                    </tr>
                                `;
                                countSchedules++;
                                countTotalSchedules++;
                            }

                            html += `
                                ${agendaHtml}
                                <tr style="background:rgba(0, 0, 0, 0.05); color:#000;">
                                    <td colspan=8>Total de ${hunterName}: ${countSchedules}</td>
                                </tr>
                            `;
                        }

                        $('.js-business-branch-report-new-patientes-table-footer').html(`
                            <tr>
                                <td colspan=8>Contagem Total: ${countTotalSchedules}</td>
                            </tr>
                        `);

                        $('.js-business-branch-report-new-patientes-table-list').html(html);

                        $('.js-tabularinfo').bootstrapTable({
                            escape: false,
                            showHeader: false
                        });
                        break;
                    }
                    case 'HOMEPAGE_REPORT_BRANCH_AGENDA': {
                        var data = this.responses.HOMEPAGE_REPORT_BRANCH_AGENDA.data;
                        $('.js-view-business-branch-report-new-patients-dialog-title-id').html(`${this.responses.HOMEPAGE_REPORT_BRANCH_AGENDA_PRESET.filialNome} (#${this.responses.HOMEPAGE_REPORT_BRANCH_AGENDA_PRESET.filialId}) - ${this.responses.HOMEPAGE_REPORT_BRANCH_AGENDA.start_date} ${this.responses.HOMEPAGE_REPORT_BRANCH_AGENDA.end_date ? ' ~ ' + this.responses.HOMEPAGE_REPORT_BRANCH_AGENDA.end_date : ''}`)
                        $('.js-view-business-branch-report-new-patient-container').html(`
                            <table id="js-view-business-branch-report-new-patient-table" class="table-striped table-hover w-100 responsive-table">
                                <thead>
                                    <tr>
                                        <th width="1%"></th>
                                        <th data-field="" width="5%">ID</th>
                                        <th data-field="" width="8%">Categoria</th>
                                        <th data-field="" width="10%">Data</th>
                                        <th data-field="" width="20%">Cliente</th>
                                        <th data-field="" width="10%">Origem</th>
                                        <th data-field="" width="10%">Doutor</th>
                                        <th data-field="" width="10%">Contato</th>
                                    </tr>
                                </thead>
                                <tbody class="js-business-branch-report-new-patientes-table-list">
                                    
                                </tbody>
                                <tfoot class="js-business-branch-report-new-patientes-table-footer">
                                </tfoot>
                            </table>
                        `)

                        let html = '',
                            countTotalSchedules = 0,
                            quantitative = [];

                        for (let i = 0; i < Object.entries(data).length; ++i) {
                            let hunterName = Object.keys(data)[i];
                            let info = Object.entries(data)[i];
                            let agendaHtml = '';
                            let countSchedules = 0;

                            //console.log('hunterName', hunterName);
                            //console.log('info', info);

                            for (let x = 0; x < info[1].length; ++x) {
                                const agendamento = info[1][x];
                                let clientDados = ['', ''];
                                const $color = getCategoryColor(agendamento.obj.CATEGORIA);
                                let isEncaixe = false;

                                if (agendamento.obj.CLIENTE_DADOS) {
                                    clientDados = agendamento.obj.CLIENTE_DADOS.split("|");
                                }

                                let logs = '';
                                let agendaLogs = JSON.parse(agendamento.obj.AGENDA_LOGS) || [];
                                for (let i = 0; i < agendaLogs.length; ++i) {
                                    let obj1 = agendaLogs[i];
                                    logs += `${obj1.CATEGORIA} - ${obj1.USUARIO_DATA} - ${obj1.USUARIO_LOGIN}&#013;&#013;`

                                    if (obj1.CATEGORIA == getAgendaCategoryByRole('AGENDADO')) {
                                        if (moment(obj1.USUARIO_DATA).isSame(moment(agendamento.obj.DATA_INICIO), 'day')) {
                                            isEncaixe = true;
                                        }
                                    }
                                }

                                let origin = '';
                                if (agendamento.obj.ORIGEM_ID !== null) {
                                    for (let i = 0; i < window._sessionData.origins.length; ++i) {
                                        if (window._sessionData.origins[i].ID == agendamento.obj.ORIGEM_ID) {
                                            origin = window._sessionData.origins[i].ORIGEM;
                                            break;
                                        }
                                    }
                                }

                                agendaHtml += `
                                    <tr data-href="#" style="${isEncaixe ? 'background:rgba(245, 212, 66, 0.3); color:#000;' : ''}">
                                        <td><i class="fas fa-info" data-tippy-content="${logs}"></i></td>
                                        <td data-label="ID">${agendamento.obj.ID}</td>
                                        <td data-label="CATEGORIA" style="background-color:${$color} !important; color:black;">${agendamento.obj.CATEGORIA}</td>
                                        <td data-label="DATA">${agendamento.startFormatted} das ${agendamento.obj.HORA_INICIO_FORMATED} às ${agendamento.obj.HORA_FINAL_FORMATED}</td>
                                        <td data-label="CLIENTE">${clientDados[0]}</td>
                                        <td data-label="ORIGEM">${origin}</td>
                                        <td data-label="DOUTOR(A)">${agendamento.obj.DOUTOR_NOME} (${agendamento.obj.DOUTORES_ID})</td>
                                        <td data-label="CONTATO">${clientDados[1]}</td>
                                    </tr>
                                `;
                                countSchedules++;
                                countTotalSchedules++;

                                quantitative[agendamento.obj.CATEGORIA] = quantitative[agendamento.obj.CATEGORIA] ? quantitative[agendamento.obj.CATEGORIA] + 1 : 1;
                            }

                            html += `
                                ${agendaHtml}
                                <tr style="background:rgba(0, 0, 0, 0.05); color:#000;">
                                    <td colspan=8>Total de ${hunterName}: ${countSchedules}</td>
                                </tr>
                            `;
                        }

                        $('.js-business-branch-report-new-patientes-table-footer').html(`
                            <tr>
                                <td colspan=8>
                                    Contagem Total: ${countTotalSchedules}<br />
                                    <div class="divider"></div>
                                    ${Object.entries(quantitative).map(([category, count]) => `<span style="display:block;">${category}: ${count}</span>`).join('')}
                                </td>
                                
                            </tr>
                        `);

                        $('.js-business-branch-report-new-patientes-table-list').html(html);

                        $('.js-tabularinfo').bootstrapTable({
                            escape: false,
                            showHeader: false
                        });
                        break;
                    }
                    case 'HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS': {
                        var data = this.responses.HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS.data;
                        var data_pn = this.responses.HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS.data_pn;
                        var data_pim = this.responses.HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS.data_pim;
                        var data_contaazul = this.responses.HOMEPAGE_REPORT_BRANCH_NEW_CONTRACTS.data_contaazul;

                        $('.js-view-business-branch-report-new-contracts-container').html(`
                            <table id="js-view-business-branch-report-new-contracts-table" class="table-striped table-hover w-100 responsive-table">
                                <thead>
                                    <tr>
                                        <th width="1%"></th>
                                        <th data-field="" width="8%">Filial</th>
                                        <th data-field="" width="8%">Qtd PNs</th>
                                        <!--<th data-field="" width="10%">Usuário</th>-->
                                        <th data-field="" width="10%">Qtd de Planos</th>
                                        <th data-field="" width="10%">Qtd de Planos (Manutenção)</th>
                                        <th data-field="" width="10%">Qtd de Sessões</th>
                                        <th data-field="" width="10%">Faturamento hoje</th>
                                    </tr>
                                </thead>
                                <tbody class="js-business-branch-report-new-contracts-table-list">
                                    
                                </tbody>
                                <tfoot class="js-business-branch-report-new-contracts-table-footer">
                                </tfoot>
                            </table>
                        `);

                        let html = '',
                            foundBranches = [],
                            notFoundBranches = [],
                            notFoundBranchesIds = [],
                            countTotalPnsByBusinessBranches = 0,
                            countTotalPlansSold = 0,
                            countTotalMaitenancePlansSold = 0,
                            countTotalPlanSessionsSold = 0,
                            countTotalBillingReport = 0;

                        for (let i in data) {
                            let branchContractsData = data[i];

                            let branchName = '';
                            let countPnByBusinessBranch = 0;
                            let countPimByBusinessBranch = 0;
                            for (let x in window._sessionData.businessBranches) {
                                if (window._sessionData.businessBranches[x].ID == branchContractsData.FILIAL_ID) {
                                    console.log('this.onlyFranchise', this.onlyFranchise);
                                    console.log('window._sessionData.businessBranches[x].FRANQUIADO', window._sessionData.businessBranches[x].FRANQUIADO);
                                    if ((this.onlyFranchise && window._sessionData.businessBranches[x].FRANQUIADO == 0) || (!this.onlyFranchise && window._sessionData.businessBranches[x].FRANQUIADO == 1))
                                        continue;
                                    if (window._sessionData.businessBranches[x].ATIVO == 0)
                                        continue;
                                    branchName = window._sessionData.businessBranches[x].FILIAL;
                                    foundBranches.push(window._sessionData.businessBranches[x].ID);
                                    break;
                                }
                            }

                            if (branchName == '')
                                continue;

                            for (let x in data_pn) {
                                if (data_pn[x].FILIAL_ID == branchContractsData.FILIAL_ID) {
                                    countPnByBusinessBranch = parseInt(data_pn[x].TOTAL_PN);
                                }
                            }

                            let pimSessions = 0;
                            for (let x in data_pim) {
                                if (data_pim[x].FILIAL_ID == branchContractsData.FILIAL_ID) {
                                    countPimByBusinessBranch = parseInt(data_pim[x].TOTAL_PIM);
                                    pimSessions = parseInt(data_pim[x].TOTAL_SESSOES);
                                }
                            }

                            let faturamentoAteHoje = 0;
                            let isContaAzulConnected = true;
                            for (let x in data_contaazul) {
                                if (data_contaazul[x].FILIAL_ID == branchContractsData.FILIAL_ID) {
                                    if (data_contaazul[x].FATURAMENTO_ATE_HOJE == 0) {
                                        isContaAzulConnected = false;
                                    }
                                    faturamentoAteHoje = parseFloat(data_contaazul[x].FATURAMENTO_HOJE);
                                }
                            }

                            // isContaAzulConnected ? '<span data-tippy-content="Conectado com Conta Azul">🟢</span>' : '<span data-tippy-content="Desconectado do Conta AZUL">🔴</span>'

                            html += `
                                <tr>
                                    <td><span data-tippy-content="Conectada">🟢</span></td>
                                    <td data-label="Filial">${branchName}</td>
                                    <td data-label="Total PN">${countPnByBusinessBranch}</td>
                                    <!--<td data-label="Usuário">${branchContractsData.USUARIO_LOGIN}</td>-->
                                    <td data-label="Total PIT">${branchContractsData.TOTAL_PIT}</td>
                                    <td data-label="Total PIM">${countPimByBusinessBranch}</td>
                                    <td data-label="Total Sessões">${parseInt(pimSessions) + parseInt(branchContractsData.TOTAL_SESSOES)}</td>
                                    <td data-label="Faturamento hoje"><b>$${parseFloat(faturamentoAteHoje).toFixed(2)}</b></td>
                                </tr>
                            `;

                            countTotalPnsByBusinessBranches = countTotalPnsByBusinessBranches + countPnByBusinessBranch;
                            countTotalPlansSold = countTotalPlansSold + parseInt(branchContractsData.TOTAL_PIT);
                            countTotalMaitenancePlansSold = countTotalMaitenancePlansSold + countPimByBusinessBranch;
                            countTotalPlanSessionsSold = pimSessions + countTotalPlanSessionsSold + parseInt(branchContractsData.TOTAL_SESSOES);
                            countTotalBillingReport = countTotalBillingReport + parseFloat(faturamentoAteHoje);
                        }


                        for (let x in window._sessionData.businessBranches) {
                            let found = false;
                            for (let y in foundBranches) {
                                if (window._sessionData.businessBranches[x].ID === foundBranches[y]) {
                                    found = true;
                                    break;
                                }
                            }
                            if (!found) {
                                notFoundBranches.push(window._sessionData.businessBranches[x])
                                notFoundBranchesIds.push(window._sessionData.businessBranches[x].ID)
                            }
                        }

                        for (let x in notFoundBranches) {
                            let notFoundBranchesData = notFoundBranches[x];
                            let notFoundBranchesIdsData = notFoundBranchesIds[x];
                            if (notFoundBranchesData.FILIAL == 'THE QUIRO' || notFoundBranchesData.ATIVO == 0 || (this.onlyFranchise && notFoundBranchesData.FRANQUIADO == 0) || (!this.onlyFranchise && notFoundBranchesData.FRANQUIADO == 1))
                                continue;

                            let countPnByBusinessBranch = 0;
                            for (let y in data_pn) {
                                if (data_pn[y].FILIAL_ID == notFoundBranchesIdsData) {
                                    countPnByBusinessBranch = parseInt(data_pn[y].TOTAL_PN);
                                    countTotalPnsByBusinessBranches = countTotalPnsByBusinessBranches + countPnByBusinessBranch;
                                }
                            }

                            let countPimByBusinessBranch = 0;
                            let pimSessions = 0;
                            for (let y in data_pim) {
                                if (data_pim[y].FILIAL_ID == notFoundBranchesIdsData) {
                                    countPimByBusinessBranch = parseInt(data_pim[y].TOTAL_PIM);
                                    //countPimByBusinessBranch = countTotalMaitenancePlansSold + countPimByBusinessBranch;
                                    pimSessions = parseInt(data_pim[y].TOTAL_SESSOES);
                                }
                            }

                            let countBillingReport = 0;
                            let isContaAzulConnected = true;
                            for (let y in data_contaazul) {
                                if (data_contaazul[y].FILIAL_ID == notFoundBranchesIdsData) {
                                    if (data_contaazul[y].FATURAMENTO_ATE_HOJE == 0) {
                                        isContaAzulConnected = false;
                                    }
                                    countBillingReport = parseFloat(data_contaazul[y].FATURAMENTO_HOJE);
                                    countTotalBillingReport = countTotalBillingReport + countBillingReport;
                                }
                            }

                            //let isContaAzulConnectedIcon = isContaAzulConnected ? '<span data-tippy-content="Conectado com Conta Azul">🟢</span>' : '<span data-tippy-content="Desconectado do Conta AZUL">🔴</span>';
                            let isContaAzulConnectedIcon = '<span data-tippy-content="Conectado">🟢</span>';

                            html += `
                                <tr>
                                    <td>${isContaAzulConnectedIcon}</td>
                                    <td data-label="Filial">${notFoundBranchesData.FILIAL}</td>
                                    <td data-label="Total PN">${countPnByBusinessBranch}</td>
                                    <td data-label="Total PIT">0</td>
                                    <td data-label="Total PIM">${countPimByBusinessBranch}</td>
                                    <td data-label="Total Sessões">${pimSessions}</td>
                                    <td data-label="Faturamento hoje"><b>$${parseFloat(countBillingReport).toFixed(2)}</b></td>
                                </tr>
                            `;

                            countTotalMaitenancePlansSold = countTotalMaitenancePlansSold + countPimByBusinessBranch;
                            countTotalPlanSessionsSold += pimSessions;
                        }

                        $('.js-business-branch-report-new-contracts-table-footer').html(`
                                <tr>
                                    <td></td>
                                    <td data-label="Total"><b>TOTAL</b></td>
                                    <td data-label="Soma PN"><b>${countTotalPnsByBusinessBranches}</b></td>
                                    <td data-label="Soma PIT"><b>${countTotalPlansSold}</b></td>
                                    <td data-label="Soma PIM"><b>${countTotalMaitenancePlansSold}</b></td>
                                    <td data-label="Soma Sessões"><b>${countTotalPlanSessionsSold}</b></td>
                                    <td data-label="Soma Fat. hoje"><b>R$ ${parseFloat(countTotalBillingReport).toFixed(2)}</b></td>
                                </tr>
                            `);
                        $('.js-business-branch-report-new-contracts-table-list').html(html);

                        mountSortList('#js-view-business-branch-report-new-contracts-table', '.js-business-branch-report-new-contracts-table-list tr:first td', 1)
                    }
                }
                break;
            }
            case 'HOMEPAGE_MANAGER': {
                switch (sub_type) {
                    case 'MANAGER_DASHBOARD_INDEXES': {
                        console.log('this.responses.MANAGER_DASHBOARD_INDEXES', this.responses.MANAGER_DASHBOARD_INDEXES);
                        let result = this.responses.MANAGER_DASHBOARD_INDEXES.results;

                        $('.js-manager-total-leads').html(result.current_month_total_leads);
                        $('.js-manager-total-new-patients').html(result.current_month_total_new_patient_avaliations);
                        $('.js-manager-total-new-patients-plans').html(result.current_month_total_new_patient_plans);
                        $('.js-manager-total-patients-starting-maintenance').html(result.current_month_total_pim_attended);
                        $('.js-manager-leads-not-contacted').html(`
                            ${result.current_month_total_leads_not_contacted > 0 ? `
                                <div class="alert alert-danger" role="alert" style="font-size: 16px !important;">
                                    <strong>${result.current_month_total_leads_not_contacted}</strong> leads não contatados <i class="fas fa-info-circle" data-tippy-content="Acesse a página de 'Leads' e filtre com a opção 'Tipo de Lead' e selecione 'Não entrou em contato'."></i>
                                </div>
                            ` : `
                                <div class="alert alert-success" role="alert" style="font-size: 16px !important;">
                                    Todos os leads foram contatados. Agora a respescagem é com você! <i class="fas fa-info-circle" data-tippy-content="Acesse a página de 'Leads' e procure por leads que ainda não Agendaram."></i>
                                </div>
                            `}
                        `)

                        let pnAttendedOriginsTableHtml = '';
                        for (let i in result.current_month_pn_attended_origins) {
                            let origin = result.current_month_pn_attended_origins[i];

                            pnAttendedOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PN-TOTAL-SCHEDULES-ATTENDED">
                                <td>${origin.ORIGEM_NAME}<br><small>100%</small></td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-manager-pn-origins-table').html(pnAttendedOriginsTableHtml);

                        pnAttendedOriginsTableHtml = '';
                        for (let i in result.current_month_pit_attended_origins) {
                            let origin = result.current_month_pit_attended_origins[i];
                            let conversionFromAttendedPnToPit = this.getOriginConversionRate(origin.ORIGEM_NAME, Number(origin.TOTAL_SCHEDULES), result.current_month_pn_attended_origins)

                            pnAttendedOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PIT-TOTAL">
                                <td>${origin.ORIGEM_NAME}<br><small>(Conv: ${conversionFromAttendedPnToPit}%)</small></td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-manager-pit-origins-table').html(pnAttendedOriginsTableHtml);

                        pnAttendedOriginsTableHtml = '';
                        for (let i in result.current_month_pim_attended_origins) {
                            let origin = result.current_month_pim_attended_origins[i];
                            let conversionFromAttendedPitToPim = this.getOriginConversionRate(origin.ORIGEM_NAME, Number(origin.TOTAL_SCHEDULES), result.current_month_pit_attended_origins)

                            pnAttendedOriginsTableHtml += `<tr class="js-report-marketing-pn-schedules-origins" data-origin-id="${origin.ORIGEM_NAME}" data-type="PIM-TOTAL">
                                <td>${origin.ORIGEM_NAME}<br><small>(Conv: ${conversionFromAttendedPitToPim}%)</small></td>
                                <td>${origin.TOTAL_SCHEDULES}</td>
                            </tr>`;
                        }
                        $('.js-manager-pim-origins-table').html(pnAttendedOriginsTableHtml);

                        window.reloadIconss();
                        break;
                    }
                }
                break;
            }
        }
    }

    getOriginConversionRate(originName, originTotalSchedules, comparision_data) {
        let conversionRate = 0;
        for (let i in comparision_data) {
            let origin = comparision_data[i];
            if (origin.ORIGEM_NAME === originName) {
                conversionRate = parseFloat((originTotalSchedules / origin.TOTAL_SCHEDULES) * 100).toFixed(2);
                break;
            }
        }
        return conversionRate;
    }

    bindDOMEvents() {
        let self = this;

        // Define padrão de opções de datas pré-configuradas para os relatórios do Dashboard
        var rangeStartDate = moment().startOf('month'),
            rangeEndDate = moment().endOf('day'),
            rangeAgendaReportStartDate = moment().startOf('day'),
            rangeOptions = {
                'Hoje': [moment().startOf('day'), moment().startOf('day')],
                'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
                'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
                'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            };

        // Caso seja um Administrador ou Gerente, muda o padrão de datas pré-configuradas
        if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR') || self.deps.userHasRole('MANAGER')) {
            rangeStartDate = this.deps.getNextBusinessDay();
            rangeEndDate = this.deps.getNextBusinessDay();
            rangeOptions = {
                'Hoje': [moment().startOf('day'), moment().startOf('day')],
                'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
                'Próximos 7 Dias': [moment(), moment().add(6, 'days')],
                'Próximos 30 Dias': [moment(), moment().add(30, 'days')],
                'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 Dias': [moment().subtract(30, 'days'), moment()],
                'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            };
        }

        // Detecta seleção de data no date ranger picker do dashboard
        $('.js-report-homepage-glass-door-period').daterangepicker({
            opens: 'left',
            startDate: rangeStartDate,
            endDate: rangeEndDate,
            opens: "right",
            drops: "down",
            locale: window._sessionData.i8nDateRangePicker,
            ranges: rangeOptions,
        }, function (start, end, label) {
            //console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
            // Verifica se é um usuário administrativo
            // caso seja, recarrega o único relatório 
            // administrativo que permite configuração de datas
            if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR')) {
                self.periods['HOMEPAGE_HUNTER_GLASS_DOOR'] = `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadBusinessHuntersGlassDoor(true);
            }

            // Verifica se é um usuário vendedor
            // caso seja, recarrega relatórios
            // informativos do vendedor
            if (self.deps.userHasRole('SELLER')) {
                self.periods['HOMEPAGE_HUNTER_INSIGHTS'] = `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadHunterInsights(false)
                    .then(() => {
                        //console.log('re render hunter meta report')
                    })
                    .then(() => {
                        self.loadHunterGoals(true)
                    });
            }
        });

        // Detecta clique para aplicar data selecionada no date range picker do dashboard
        $('.js-report-homepage-glass-door-period').on('apply.daterangepicker', function (ev, picker) {
            // Verifica se é um usuário administrativo
            // caso seja, recarrega o único relatório 
            // administrativo que permite configuração de datas
            if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR')) {
                self.periods['HOMEPAGE_HUNTER_GLASS_DOOR'] = `${picker.startDate.format('YYYY-MM-DD 00:00:00.000')}|${picker.endDate.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadBusinessHuntersGlassDoor(true);
            }

            // Verifica se é um usuário vendedor
            // caso seja, recarrega relatórios
            // informativos do vendedor
            if (self.deps.userHasRole('SELLER')) {
                self.periods['HOMEPAGE_HUNTER_INSIGHTS'] = `${picker.startDate.format('YYYY-MM-DD 00:00:00.000')}|${picker.endDate.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadHunterInsights(false)
                    .then(() => {
                        //console.log('re render hunter meta report')
                    })
                    .then(() => {
                        self.loadHunterGoals(true)
                    });
            }

            setTimeout(() => {
                $('.js-report-homepage-glass-door-period').val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`)
            }, 1000);
        });

        // Detecta seleção de data no date ranger picker do dashboard
        $('.js-report-homepage-agenda-period').daterangepicker({
            opens: 'left',
            startDate: rangeAgendaReportStartDate,
            endDate: rangeEndDate,
            opens: "right",
            drops: "down",
            locale: window._sessionData.i8nDateRangePicker,
            ranges: rangeOptions,
        }, function (start, end, label) {
            //console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
            // Verifica se é um usuário administrativo
            // caso seja, recarrega o único relatório 
            // administrativo que permite configuração de datas
            if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR') || self.deps.userHasRole('SELLER') || self.deps.userHasRole('COMMERCIAL_ASSISTANT') || self.deps.userHasRole('manager')) {
                self.periods['HOMEPAGE_AGENDA_REPORT'] = `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadBusinessAgenda(true);
            }
        });

        // Detecta clique para aplicar data selecionada no date range picker do dashboard
        $('.js-report-homepage-agenda-period').on('apply.daterangepicker', function (ev, picker) {
            // Verifica se é um usuário administrativo
            // caso seja, recarrega o único relatório 
            // administrativo que permite configuração de datas
            if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR') || self.deps.userHasRole('SELLER') || self.deps.userHasRole('ADMIN') || self.deps.userHasRole('COMMERCIAL_ASSISTANT') || self.deps.userHasRole('MANAGER')) {
                self.periods['HOMEPAGE_AGENDA_REPORT'] = `${picker.startDate.format('YYYY-MM-DD 00:00:00.000')}|${picker.endDate.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadBusinessAgenda(true);
            }

            //console.log('agenda period', picker.startDate);

            setTimeout(() => {
                $('.js-report-homepage-agenda-period').val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`)
            }, 1000);
        });

        // Detecta seleção de data no date ranger picker do dashboard da Clínica
        $('.js-homepage-manager-date-filter').daterangepicker({
            opens: 'left',
            startDate: moment().startOf('month'),
            endDate: moment().endOf('day'),
            opens: "right",
            drops: "down",
            locale: window._sessionData.i8nDateRangePicker,
            ranges: rangeOptions,
        }, function (start, end, label) {
            //console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
            // Verifica se é um usuário administrativo
            // caso seja, recarrega o único relatório 
            // administrativo que permite configuração de datas
            if (self.deps.userHasRole('MANAGER') || self.deps.userHasRole('COMMERCIAL_ASSISTANT')) {
                self.periods['HOMEPAGE_MANAGER'] = `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`;
                self.loadManagerInsights(true);
            }
        });

        $('.js-report-homepage-agenda-report-categories').select2();

        // Detecta clique para filtrar "Relatório Agenda" por uma categoria específica
        $('.js-report-homepage-agenda-report-categories').change(function () {
            self.categories.HOMEPAGE_AGENDA_REPORT = $(this).val().join(',');
            //console.log('self.categories.HOMEPAGE_AGENDA_REPORT', self.categories.HOMEPAGE_AGENDA_REPORT);
            self.loadBusinessAgenda(true);
        });

        // Detecta clique do operador para selecionar período do relatório HOMEPAGE_PIT_PN_LAST_7_DAYS > PIT_PN_REPORT
        $(document).on('click', '.js-report-pit-pim-period', function () {
            let reportType = $(this).data('report'),
                reportSubType = $(this).data('sub-type'),
                reportPeriod = $(this).data('period');

            self.periods[reportType] = reportPeriod;
            self.loadBusinessInsightsPitPimPnLast7Days(false).then(() => {
                //console.log('re render pitpim report')
                self.renderDashboardReport(reportType, reportSubType, self.periods[reportType]);
            });
        });

        // Detecta clique para selecionar período do relatório HOMEPAGE_PIT_PN_LAST_7_DAYS > PN_PR_REPORT
        $(document).on('click', '.js-report-pn-pr-period', function () {
            let reportType = $(this).data('report'),
                reportSubType = $(this).data('sub-type'),
                reportPeriod = $(this).data('period');

            self.periods[reportType] = reportPeriod;
            self.loadBusinessInsightSchedulments7Days(false).then(() => {
                //console.log('re render pitpim report')
                self.renderDashboardReport(reportType, reportSubType, self.periods[reportType]);
            });
        });

        // Deteca clique para atualizar relatório de GOALS do hunter
        $(document).on('click', '.js-report-hunter-meta-period', function () {
            let reportType = $(this).data('report'),
                reportSubType = $(this).data('sub-type'),
                reportPeriod = $(this).data('period');

            self.periods[reportType] = reportPeriod;
            self.loadHunterGoals(true).then(() => {
                //console.log('re render pitpim report')
                self.renderDashboardReport(reportType, reportSubType, self.periods[reportType]);
            });
        });

        // Detecta clique para visualizar "Relatório de Novos Pacientes" de uma clinica
        // do "Relatório D+1"
        $(document).on('click', '.js-dashboard-business-branch-new-patients-view-report', function (e) {
            let filialId = $(this).data('filial');
            let filialNome = $(this).data('filial-nome');
            self.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS_PRESET = {
                filialId,
                filialNome
            };
            $('.js-view-business-branch-report-new-patient-container').block(window._loader.loading);
            self.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/employee/agenda_report',
                data: {
                    report: 'HOMEPAGE_BRANCH_REPORT_NEW_PATIENTS',
                    branchId: filialId,
                    period: self.periods.HOMEPAGE_HUNTER_GLASS_DOOR
                },
                successCallback: function (res) {
                    console.log('dashboard.js/click/.js-dashboard-business-branch-new-patients-view-report', 'HOMEPAGE_BRANCH_REPORT_NEW_PATIENTS', res);
                    self.responses.HOMEPAGE_REPORT_BRANCH_AGENDA = false;
                    self.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS = res;
                    self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS');
                },
                errorCallback(err) {
                    $('.js-view-business-branch-report-new-patient-container').block(window._loader.error);
                    console.error('dashboard.js/click/.js-dashboard-business-branch-new-patients-view-report', 'HOMEPAGE_BRANCH_REPORT_NEW_PATIENTS', err);
                }
            });
        });

        // Detecta clique para visualizar "Relatório de Novos Pacientes" de uma clinica
        // do "Relatório D+1"
        $(document).on('click', '.js-dashboard-business-branch-agenda-view-report', function (e) {
            let filialId = $(this).data('filial');
            let filialNome = $(this).data('filial-nome');
            self.responses.HOMEPAGE_REPORT_BRANCH_AGENDA_PRESET = {
                filialId,
                filialNome
            };
            $('.js-view-business-branch-report-new-patient-container').block(window._loader.loading);
            self.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/employee/agenda_report',
                data: {
                    report: 'HOMEPAGE_BRANCH_REPORT_AGENDA',
                    branchId: filialId,
                    period: self.periods.HOMEPAGE_AGENDA_REPORT,
                    categories: self.categories.HOMEPAGE_AGENDA_REPORT
                },
                successCallback: function (res) {
                    console.log('dashboard.js/click/.js-dashboard-business-branch-agenda-view-report', 'HOMEPAGE_BRANCH_REPORT_AGENDA', res);
                    self.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS = false;
                    self.responses.HOMEPAGE_REPORT_BRANCH_AGENDA = res;
                    self.renderDashboardReport('HOMEPAGE_HUNTER_INSIGHTS', 'HOMEPAGE_REPORT_BRANCH_AGENDA');
                },
                errorCallback(err) {
                    $('.js-view-business-branch-report-new-patient-container').block(window._loader.error);
                    console.error('dashboard.js/click/.js-dashboard-business-branch-agenda-view-report', 'HOMEPAGE_BRANCH_REPORT_AGENDA', err);
                }
            });
        });

        // HUNTER: Detecta clique para ver comissão
        $(document).on('click', '.js-view-wallet', function () {
            if (self.charts.HUNTER_GOALS_REPORT) {
                if ($(this).hasClass('fa-eye-slash')) {
                    self.charts.HUNTER_GOALS_REPORT.updateOptions({
                        title: {
                            text: self.cache.HUNTER_PN_GOAL_STRING + ` (R$${self.cache.HUNTER_PN_GOAL_VALUE})`
                        }
                    })
                    $(this).removeClass('fa-eye-slash');
                    $(this).addClass('fa-eye');
                } else {
                    self.charts.HUNTER_GOALS_REPORT.updateOptions({
                        title: {
                            text: self.cache.HUNTER_PN_GOAL_STRING + ` (R$****)`
                        }
                    })
                    $(this).addClass('fa-eye-slash');
                    $(this).removeClass('fa-eye');
                }
            }
        });

        // RELATÓRIO: Detecta clique na ação de exportar o relatório "Relatório D+1" para Excel
        $('.js-export-glass-door-excel').on('click', function (e) {
            e.preventDefault();
            let data = self.responses.HOMEPAGE_HUNTER_GLASS_DOOR_EXPORT;
            const worksheet = XLSX.utils.json_to_sheet(data);

            // Create a workbook and add the worksheet to it
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Export the workbook to an Excel file
            XLSX.writeFile(workbook, 'relatorio_d1_' + window.getSaoPauloDateTime() + '.xlsx');

            window.toast({
                error: false,
                text: "Exportação realizada com sucesso."
            })
        });

        // RELATÓRIO: Detecta clique na ação de exportar o relatório "Relatório Agenda" para Excel
        $('.js-export-agenda-excel').on('click', function (e) {
            e.preventDefault();
            let data = self.responses.HOMEPAGE_AGENDA_REPORT_EXPORT;
            const worksheet = XLSX.utils.json_to_sheet(data);

            // Create a workbook and add the worksheet to it
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Export the workbook to an Excel file
            XLSX.writeFile(workbook, 'relatorio_agenda_' + window.getSaoPauloDateTime() + '.xlsx');

            window.toast({
                error: false,
                text: "Exportação realizada com sucesso."
            })
        });

        // Detecta clique para exportar relatório "Novos Pacientes" que é visualizado
        // ao clicar em uma das filiais do "Relatório D+1"
        $('.js-dashboard-branch-report-new-patients-export-excel').on('click', function (e) {
            e.preventDefault();
            let data = self.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS ? self.responses.HOMEPAGE_REPORT_BRANCH_NEW_PATIENTS.data : self.responses.HOMEPAGE_REPORT_BRANCH_AGENDA.data;

            let mountData = [];

            // This is a possible way to format the XLSX npm module to show a report of current schedulments in js
            // It assumes that the data json is stored in a variable called data
            // It uses the xlsx and fs modules, which need to be installed and required
            // It creates a workbook with a worksheet called "Report"
            // It loops through the sellers names and their schedulments, and writes them in the worksheet
            // It sets the column widths and alignment
            // It saves the workbook as report.xlsx


            // Create a workbook and a worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet([]);

            // Set the headers for the schedule data
            const headers = ["Hunter", "Agenda ID", "Categoria", "Cliente", "Telefone", "Doutor(a)", "Data", "Hora Início", "Hora Final", "Quem Agendou"];
            XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

            // Set the current row and column
            let row = 2;

            // Loop through the sellers and their schedules
            for (let seller of Object.keys(data)) {
                for (let schedule of data[seller]) {
                    let splitCliente = ['', ''];

                    if (schedule.obj.CLIENTE_DADOS) {
                        splitCliente = schedule.obj.CLIENTE_DADOS.split("|");
                    }

                    let agendaLogs = JSON.parse(schedule.obj.AGENDA_LOGS);
                    let lastAgendado = null;

                    for (let i = agendaLogs.length - 1; i >= 0; i--) {
                        if (agendaLogs[i].CATEGORIA == 'Agendado') {
                            lastAgendado = agendaLogs[i].USUARIO_LOGIN;
                            break;
                        }
                    }

                    const rowData = [seller, schedule.id, schedule.obj.CATEGORIA, splitCliente[0], splitCliente[1], schedule.obj.DOUTOR_NOME, schedule.obj.DATA_INICIO_FORMATED, schedule.obj.HORA_INICIO_FORMATED, schedule.obj.HORA_FINAL_FORMATED, lastAgendado];
                    XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: `A${row}` });
                    row++;
                }
                // Leave an empty row between sellers
                row++;
            }

            // Adjust the column width for the "Cliente" column (Column D)
            worksheet["!cols"] = [
                { wch: 20 }, // Column A
                { wch: 10 }, // Column B
                { wch: 15 }, // Column C
                { wch: 50 }, // Column D (Increased to 50)
                { wch: 25 }, // Column E
                { wch: 15 }, // Column F
                { wch: 15 }, // Column G
                { wch: 15 }, // Column H
                { wch: 15 }, // Column I
                { wch: 15 }, // Column J
            ];

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

            // Save the workbook as report.xlsx
            XLSX.writeFile(workbook, "report.xlsx");

            window.toast({
                error: false,
                text: "Exportação realizada com sucesso."
            })
        });

        // Detecta clique nas métricas do hunter, para carregar as informações
        $(document).on('click', '.js-homepage-hunter-overview-insight', function (e) {
            e.preventDefault();

            let hunter = $(this).data('hunter');

            $(`#collapseHunterOverview${hunter}`).block(window._loader.loading);
            self.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/employee/insights',
                data: {
                    report: 'HOMEPAGE_HUNTER_OVERVIEW',
                    login: hunter
                },
                successCallback: function (res) {
                    console.log('dashboard.js/click/.js-homepage-hunter-overview-insight', 'HOMEPAGE_HUNTER_OVERVIEW', res);

                    const data = res.data.results;
                    //setTimeout(function() {
                    const percentageDifferenceAgendamentos = parseFloat(((data.ContagemTotalAgendamentosAtual - data.ContagemTotalAgendamentosAnterior) / data.ContagemTotalAgendamentosAnterior) * 100).toFixed(2);
                    const percentageDifferenceAgendamentosTaxaAgendXAtendidos = parseFloat(((data.ContagemAtendidosAtual - data.ContagemAtendidosAnterior) / data.ContagemAtendidosAnterior) * 100).toFixed(2);
                    const percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram = parseFloat(((data.NaoCompareceuAtualTotal - data.NaoCompareceuAnteriorTotal) / data.NaoCompareceuAnteriorTotal) * 100).toFixed(2);

                    $('.js-hunter-' + hunter + '-total-schedulments-percentage').removeClass('text-success');
                    $('.js-hunter-' + hunter + '-total-schedulments-percentage').removeClass('text-danger');
                    $('.js-hunter-' + hunter + '-total-schedulments-percentage').removeClass('text-primary');
                    if (percentageDifferenceAgendamentos > 0) {
                        $('.js-hunter-' + hunter + '-total-schedulments-percentage').html(`+${(percentageDifferenceAgendamentos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentos) ? percentageDifferenceAgendamentos : 100}%`);
                        $('.js-hunter-' + hunter + '-total-schedulments-percentage').addClass('text-success');
                    } else if (percentageDifferenceAgendamentos < 0) {
                        $('.js-hunter-' + hunter + '-total-schedulments-percentage').html(`${(percentageDifferenceAgendamentos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentos) ? percentageDifferenceAgendamentos : 100}%`);
                        $('.js-hunter-' + hunter + '-total-schedulments-percentage').addClass('text-danger');
                    } else {
                        $('.js-hunter-' + hunter + '-total-schedulments-percentage').html(`0%`);
                        $('.js-hunter-' + hunter + '-total-schedulments-percentage').addClass('text-primary');
                    }
                    $('.js-hunter-' + hunter + '-total-schedules').attr('title', `A quantidade de agendamentos de ${hunter} ${percentageDifferenceAgendamentos > 0 ? 'aumentou' : 'diminuiu'} ${(percentageDifferenceAgendamentos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentos) ? percentageDifferenceAgendamentos : 100}% comparado ao mesmo período do mês passado, onde o hunter ${hunter} realizou ${data.ContagemTotalAgendamentosAnterior} agendamentos.`)

                    $('.js-hunter-' + hunter + '-total-attend-percentage').removeClass('text-success');
                    $('.js-hunter-' + hunter + '-total-attend-percentage').removeClass('text-danger');
                    $('.js-hunter-' + hunter + '-total-attend-percentage').removeClass('text-primary');
                    if (percentageDifferenceAgendamentosTaxaAgendXAtendidos > 0) {
                        $('.js-hunter-' + hunter + '-total-attend-percentage').html(`+${(percentageDifferenceAgendamentosTaxaAgendXAtendidos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXAtendidos) ? percentageDifferenceAgendamentosTaxaAgendXAtendidos : 100}%`);
                        $('.js-hunter-' + hunter + '-total-attend-percentage').addClass('text-success');
                    } else if (percentageDifferenceAgendamentosTaxaAgendXAtendidos < 0) {
                        $('.js-hunter-' + hunter + '-total-attend-percentage').html(`${(percentageDifferenceAgendamentosTaxaAgendXAtendidos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXAtendidos) ? percentageDifferenceAgendamentosTaxaAgendXAtendidos : 100}%`);
                        $('.js-hunter-' + hunter + '-total-attend-percentage').addClass('text-danger');
                    } else {
                        $('.js-hunter-' + hunter + '-total-attend-percentage').html(`0%`);
                        $('.js-hunter-' + hunter + '-total-attend-percentage').addClass('text-primary');
                    }
                    $('.js-hunter-' + hunter + '-total-attend-current-count').html(`${data.ContagemAtendidosAtual}`);
                    $('.js-hunter-' + hunter + '-total-attend-past-count').attr('title', `A taxa de Pacientes Atendidos de ${hunter} ${percentageDifferenceAgendamentosTaxaAgendXAtendidos > 0 ? 'aumentou' : 'diminuiu'} ${(percentageDifferenceAgendamentosTaxaAgendXAtendidos) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXAtendidos) ? percentageDifferenceAgendamentosTaxaAgendXAtendidos : 100}% comparado com o mesmo período do mês passado, onde o hunter ${hunter} teve ${data.ContagemAtendidosAnterior} Pacientes Atendidos.`);

                    $('.js-hunter-' + hunter + '-total-not-attended-percentage').removeClass('text-success');
                    $('.js-hunter-' + hunter + '-total-not-attended-percentage').removeClass('text-danger');
                    $('.js-hunter-' + hunter + '-total-not-attended-percentage').removeClass('text-primary');
                    if (percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram > 0) {
                        $('.js-hunter-' + hunter + '-total-not-attended-percentage').html(`+${(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) ? percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram : 100}%`);
                        $('.js-hunter-' + hunter + '-total-not-attended-percentage').addClass('text-danger');
                    } else if (percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram < 0) {
                        $('.js-hunter-' + hunter + '-total-not-attended-percentage').html(`${(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) ? percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram : 100}%`);
                        $('.js-hunter-' + hunter + '-total-not-attended-percentage').addClass('text-success');
                    } else {
                        $('.js-hunter-' + hunter + '-total-not-attended-percentage').html(`0%`);
                        $('.js-hunter-' + hunter + '-total-not-attended-percentage').addClass('text-primary');
                    }
                    //console.log('data', data);
                    $('.js-hunter-' + hunter + '-total-non-attended-current-count').html(`${data.NaoCompareceuAtualTotal}`);
                    $('.js-hunter-' + hunter + '-total-not-attended-past-count').attr('title', `A taxa de Pacientes que Não Compareceram de ${hunter} ${percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram > 0 ? 'aumentou' : 'diminuiu'} ${(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) !== "Infinity" && !isNaN(percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram) ? percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram : 100}% comparado com o mesmo período do mês passado, onde o hunter ${hunter} teve ${data.NaoCompareceuAnteriorTotal} Pacientes que Não Compareceram.`);

                    //console.log('percentageDifferenceAgendamentos', percentageDifferenceAgendamentos);
                    //console.log('percentageDifferenceAgendamentosTaxaAgendXAtendidos', percentageDifferenceAgendamentosTaxaAgendXAtendidos);
                    //console.log('percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram', percentageDifferenceAgendamentosTaxaAgendXNaoCompareceram);

                    $('.js-hunter-' + hunter + '-total-schedulments').html(`
                            ${data.ContagemTotalAgendamentosAtual}
                        `);
                    $('.js-hunter-' + hunter + '-total-attend').html(`
                            ${data.TaxaDeAgendamentosXAtendidosAtual}%
                        `);
                    $('.js-hunter-' + hunter + '-total-not-attended').html(`
                            ${data.TaxaDeAgendamentosXNaoCompareceramAtual}%
                        `);
                    $('.js-hunter-' + hunter + '-total-comission').html(`
                            R$${parseFloat(data.ContagemAtendidosAtual) * 7}
                        `);
                    $('.js-hunter-' + hunter + '-contacts-today-value').html(data.FunilVendedor.funil_entrou_em_contato);
                    //}, 1500);

                    $(`#collapseHunterOverview${hunter}`).unblock();
                },
                errorCallback(err) {
                    $(`#collapseHunterOverview${hunter}`).block(window._loader.error);
                    console.error('dashboard.js/click/.js-homepage-hunter-overview-insight', 'HOMEPAGE_HUNTER_OVERVIEW', err);
                }
            });
        });

        // Detecta clique no switch para ser apenas dados de franquias
        $(document).on('click', '#js-only-franchise', async function () {
            self.onlyFranchise = !self.onlyFranchise;
            console.log('self.onlyFranchise', self.onlyFranchise);

            $(".js-admin-dashboard").block(window._loader.loading);

            let neededModules = [];
            let neededModulesAfter = [];

            if (self.deps.userHasRole('ADMIN') || self.deps.userHasRole('CONSULTANT') || self.deps.userHasRole('SUPERVISOR')) {
                await self.loadBusinessInsightsPitPimPnLast7Days(true);
                await self.loadBusinessInsightSchedulments7Days(true);
                await self.loadBusinessHuntersGlassDoor(true);
                await self.loadBusinessAgenda(true);
                self.loadBusinessHuntersOverviewInsights(true);
            }
            if (self.deps.userHasRole('MANAGER') || self.deps.userHasRole('COMMERCIAL_ASSISTANT')) {
                if (self.deps.userHasRole('MANAGER')) {
                    await self.loadBusinessInsightSchedulments7Days(true);
                    await self.loadBusinessHuntersGlassDoor(true);
                }
                //self.loadBusinessInsightsPitPimPnLast7Days(true);
                await self.loadBusinessInsightsPitPimPnLast7Days(true);
                await self.loadBusinessAgenda(true);
                self.loadManagerInsights(true);
            }
            if (self.deps.userHasRole('SELLER')) {
                await self.loadHunterInsights(true);
                await self.loadHunterGoals(true);
                await self.loadBusinessHuntersGlassDoor(true);
            }

            Promise.all(neededModules).then(() => {
                $(".js-admin-dashboard").unblock()
            }).then(() => {
                Promise.all(neededModulesAfter).then(() => {
                    //console.log('loaded all');
                });
            });

        });
    }
}
